export default {
  "# Call Attempts": {
    es: "Número de intento de llamadas"
  },
  "Cross Sell Policies Uncovered": {
    es: "Ofrecer nuevas coberturas o pólizas"
  },
  "# Cross Sell Policies Uncovered:": {
    es: "Ofrecer nuevas coberturas o pólizas"
  },
  "# of Children": {
    es: "Número de hijos"
  },
  "$ Value for Trigger 1": {
    es: "$ Valor de la Meta # 1"
  },
  "$ Value for Trigger 3": {
    es: "$ Valor de la Meta # 3"
  },
  "$ Value for Trigger2": {
    es: "$ Valor de la Meta # 2"
  },
  "(586) 473-1547": {
    es: "(586) 473-1547"
  },
  "(Acknowledges that you conveyed the results of the Intelligence Link to the customer)": {
    es: "(Acuerdo de condiciones según tabulador de riesgo con el cliente)"
  },
  "(hobbies, children, vacation plans, what's going on in their world)": {
    es: "(pasatiempos, hijos/as, planes de vacaciones, lo que pasa en su vida)"
  },
  "*Subscriber is responsible for understanding and complying with all applicable rules and regulations of the state in which it is operating when providing financial or insurance advice, including, but not limited to, advice regarding appropriate coverage and liability limits.": {
    es:
      '"El que subscribe esto es responsable de entender y cumplir con todas las reglas y regualciones aplicadas por el estado en el que está operando al proveer consejos financieros o de seguro, incluyendo, pero no limitándose a, dar consejos con respecto a una cobertura apropiada y los límites de endeudamiento."'
  },
  "01 January": {
    es: "01 Enero"
  },
  "02 February": {
    es: "02 Febrero"
  },
  "03 March": {
    es: "03 Marzo"
  },
  "04 April": {
    es: "04 Abril"
  },
  "05 May": {
    es: "05 Mayo"
  },
  "06 June": {
    es: "06 Junio"
  },
  "07 July": {
    es: "07 Julio"
  },
  "08 August": {
    es: "08 Agosto"
  },
  "09 September": {
    es: "09 Septiembre"
  },
  "10 October": {
    es: "10 Octubre"
  },
  "11 November": {
    es: "11 Noviembre"
  },
  "12 December": {
    es: "12 Diciembre"
  },
  "401K - Value:": {
    es: "401K = Valor:"
  },
  "401K-Value:": {
    es: "Valor del 401K"
  },
  "6 Months": {
    es: "6 Meses"
  },
  "A certificate of deposit that the bank issues to customers for a specific interest rate on the funds.  The custer has to keep the funds in the CD for the term issued by the bank.": {
    es:
      "Un certificado  de depósito que el banco expide para los clientes con una tasa de interés específico sobre esos fondos. El cliente tiene que guardar los fondos en el Cd por el tiempo establecido por el banco. "
  },
  "A certificate of deposit that the bank issues to customers for a specific interest rate on the funds. The customer has to keep the funds in the CD for the term issued by the bank.": {
    es:
      "Un certificado de depósito que el banco otorga a clientes por una tarifa de interés específica sobre los fondos. El cliente debe dejar los fondos en el CD por el tiempo determinado por el banco."
  },
  "A retirement plan offered to employees or teachers in the public schools.": {
    es:
      "Un plan de jubilación ofrecido a los empleados o maestros en las escuelas públicas"
  },
  "A retirement plan offered to government employees (e.g. police or firefighters).": {
    es:
      "Un plan de jubilación ofrecido a los empleados del gobierno (por ej. la policiía o los bomberos)."
  },
  "ADD A GAME": {
    es: "Agregar un juego"
  },
  "ADD ANOTHER": {
    es: "AGREGAR OTRO/A"
  },
  "ADD CART": {
    es: "Agregar tarjeta"
  },
  "ADD Note": {
    es: "AGREGAR notas"
  },
  APPROVE: {
    es: "APROBAR"
  },
  ARCHIVE: {
    es: "Archivo"
  },
  Archive: {
    es: "Archivo"
  },
  "Accounting and Financial Services": {
    es: "Servicios financieros y de contaduría"
  },
  "Acct's": {
    es: "Cuentas"
  },
  "Acknowledge?": {
    es: "¿Lo reconoce?"
  },
  Action: {
    es: "Acción"
  },
  "Add Another": {
    es: "AGREGAR OTRO/A"
  },
  "Add Note": {
    es: "AGREGAR notas"
  },
  "Add a Credit Card": {
    es: "Agregar una Tarjeta de Crédito"
  },
  "Add a Game": {
    es: "Agregar un juego"
  },
  "Add a Virtual Onboarder": {
    es: "Agrega un Coordinador Virtual"
  },
  Address: {
    es: "Dirección"
  },
  "Address, City State & Zip Code are mandatory.": {
    es: "Dirección, Ciudad, Estado y Correo Postal son Obligatorios"
  },
  "Administrative Support": {
    es: "Apoyo administrativo"
  },
  Adress: {
    es: "Dirección"
  },
  "Advertising and Marketing": {
    es: "Publicidad y Mercado"
  },
  "Agency Address": {
    es: "Dirección de la Agencia"
  },
  "Agency B-File Opportunities": {
    es: "Oportunidades de la Agencia B-File"
  },
  "Agency Info": {
    es: "Información de la agencia"
  },
  "Agency Life and/or Retirement Activity": {
    es: "Agencias de vida y o actividades de jubilación"
  },
  "Agency Name": {
    es: "Nombre de la Agencio"
  },
  "Agency Partners Detail": {
    es: "Detalles de los Socios de la Agencia"
  },
  "Agency Profile": {
    es: "Perfil de la Agencia"
  },
  Agency: {
    es: "Agencia"
  },
  Agent: {
    es: "Agente"
  },
  Ages: {
    es: "Edad(es)"
  },
  "Ages:": {
    es: "Edades:"
  },
  "All B-Files": {
    es: "Todos los Archivos-B"
  },
  "All Bfiles": {
    es: "Todos los B-Files"
  },
  "All Customers": {
    es: "Todos los Clientes"
  },
  All: {
    es: "Todo"
  },
  "Also, feel free to give me a buzz when you get a minute and we can introduce ourselves.": {
    es:
      "Asimismo, por favor siéntanse en libertad de llamarme por teléfono  cuando tengan un tiempo para poder presentarnos"
  },
  "Alternate Phone Number": {
    es: "Otro teléfono"
  },
  'Always ask "Did I catch you at an OK time"': {
    es: 'Siempre preguntar: "¿Tiene usted tiempo para conversar?"'
  },
  "Amount Paid": {
    es: "Monto Pagado"
  },
  "Amount to give on the gift card?": {
    es: "¿Cantidad a dar en tarjeta de regalo?"
  },
  Amount: {
    es: "Montos"
  },
  "Amount:": {
    es: "Montos:"
  },
  "An account established by a customer to purchase mutual funds or stocks.": {
    es:
      "Una cuenta establecida por el cliente para comprar fondos mutuos o acciones."
  },
  "An account usually held at a bank.  Interest paid on the funds are usually higher than a checking account.": {
    es:
      "Un certificado  de depósito que el banco expide para los clientes con una tasa de interés específico sobre esos fondos. El cliente tiene que guardar los fondos en el Cd por el tiempo establecido por el banco. "
  },
  "An account usually held at bank. Interest paid on funds are usually higher than a checking account.": {
    es:
      "Una cuenta usualmente en un banco. Los intereses pagados por fondos son por lo general más altos que una cuenta corriente."
  },
  "An employer sponsored retirement plan offered to employees to help save for retirement.  Money is usually payroll deducted.  The employee chooses the mutual funds within the plan to try and grow the funds for retirement.": {
    es:
      "Un plan de jubilación patrocinado por el empleador (patrón/a) ofrecido a los empleados para ayudarlos a ahorrar para su jubilación. El dinero es normalmente deducido del pago. El empleado escoge los fondos mutuos dentro del plan para tratar de incrementar sus fondos de jubilación."
  },
  "Animation Overview Video": {
    es: "Video explicativo de animación"
  },
  Annuities: {
    es: "Anualidades / Renta o pensión anual"
  },
  Annuity: {
    es: "Anualidad"
  },
  "Appoint. Cancelled": {
    es: "Cita cancelada"
  },
  "Appoint. Kept": {
    es: "Cita que no se canceló"
  },
  "Appoint. Made": {
    es: "Cita hecha"
  },
  "Appoint. Rescheduled": {
    es: "Reprogramar cita"
  },
  "Appoint. Sold": {
    es: "Cita y venta"
  },
  "Appointment Outcome Notes": {
    es: "Notas de la cita"
  },
  "Appointment Outcome": {
    es: "Resultado de la cita"
  },
  "Appointment Scheduled": {
    es: "Cita Programada"
  },
  "Appointments Kept": {
    es: "Citas mantenidas"
  },
  "Appointments Made": {
    es: "Citas realizadas"
  },
  "Appointments Sold": {
    es: "Citas de Venta"
  },
  Approve: {
    es: "APROBAR"
  },
  April: {
    es: "Abril"
  },
  "Architects and Engineers": {
    es: "Arquitectos e Ingenieros"
  },
  "Archive B-File": {
    es: "Archivar Archivo-B"
  },
  Archived: {
    es: "Archivado"
  },
  Archives: {
    es: "Archivos"
  },
  "Are you sure you want to unlink this user?": {
    es: "¿Está usted seguro de que quiere desenlazar (unlink) a este usuario?"
  },
  "Ask how your customer's day is going and try to build a conversation. Use the notes to build some commonality!": {
    es:
      "Pregunte cómo va el día de su cliente y trate de establecer una conversación. ¡Usa las notas para construir algo común!"
  },
  "Asset Accounts / Retirement Opportunities": {
    es: "Cuentas de activos . Oportunidades de jubilación"
  },
  "Asset Accounts On-Boarded": {
    es: "Cuentas de Bienes CoordinadosCoordinados"
  },
  "Asset Accounts": {
    es: "Cuentas de Bienes Activos"
  },
  "Asset Accounts?": {
    es: "¿Cuentas de activos?"
  },
  "Attempted Life & Retirement Calls": {
    es: "Intento de llamadas de vida y jubilación"
  },
  "Attempted to Reach": {
    es: "Se intentlizar"
  },
  August: {
    es: "Agosto"
  },
  "Auto Policy Sold fields are mandatory.": {
    es: "Póliza de Auto Vendida / Renovada es Mandatorio."
  },
  "Auto Policy Sold is Mandatory": {
    es: "Póliza de Seguro de Auto Vendido es Obligatorio"
  },
  "Auto Policy Sold/Renewed": {
    es: "Póliza de Auto Vendida / Renovada"
  },
  Auto: {
    es: "Auto"
  },
  Available: {
    es: "Disponible"
  },
  "B-FILE ACTIONS": {
    es: "ACTCIONES DE ARCHIVOS-B"
  },
  "B-File Actions": {
    es: "ACTCIONES DE ARCHIVOS-B"
  },
  "B-File Creator": {
    es: "Creador del Archivo-B"
  },
  "B-File Financial Recommendations": {
    es: "Recomendaciones financieras para el Archivo=B"
  },
  "B-File Sent": {
    es: "Archivo-B enviado"
  },
  "B-Files": {
    es: "Archivos-B"
  },
  "BFile Creator": {
    es: "Creador de Bfile"
  },
  "BFile Status": {
    es: "Archivo-B estatus"
  },
  Bakeries: {
    es: "Pastelerías"
  },
  Balance: {
    es: "Balance"
  },
  "Based on the information we just discussed, our Intelligence Link has determined that you need to protect assets in the amount of:": {
    es:
      "Basados en la información que acabamos de discutir, nuestra Calculadora de Valor de Riesgo ha determinado que usted necesita proteger las propiedades con el valor de "
  },
  "Beauty Salons and Barbers": {
    es: "Salones de Belleza y Peluquerías"
  },
  "Bfile Creator": {
    es: "Creador de Bfile"
  },
  "Billing Address": {
    es: "Dirección para cobro"
  },
  "Billing Information": {
    es: "Información de la cuenta"
  },
  Boat: {
    es: "Bote"
  },
  "Brokerage Accounts": {
    es: "Cuenta de Acciones de la Bolsa"
  },
  "Business Consultants": {
    es: "Consultores de Negocios"
  },
  "Business Name": {
    es: "Nombre del negocio"
  },
  "Business Owner": {
    es: "Propietario de Negocio"
  },
  "Business Ownership": {
    es: "Poropiedad de un negocio"
  },
  "Business Type": {
    es: "Tipo de negocio"
  },
  CANCEL: {
    es: "CANCELAR"
  },
  "CD's": {
    es: "CD's "
  },
  "CHANGE CREATOR": {
    es: "CAMBIAR CREADOR"
  },
  "CHANGE CREDIT CARD/BILLING": {
    es: "CAMBIAR TARJETA DE CRÉDITO/FACTURACIÓN"
  },
  "CHANGE PAYMENT METHOD": {
    es: "CAMBIAR MÉTODO DE PAGO"
  },
  COMPLETE: {
    es: "COMPLETAR"
  },
  COMPLETED: {
    es: "TERMINADO"
  },
  "CREATE B-FILE": {
    es: "CREAR B-FILE"
  },
  "Calendar Invites": {
    es: "Invitaciones en el calendario"
  },
  "Call #{count} Reached?": {
    es: "Llamada número {count}, ¿alcanzada?"
  },
  "Call #1 Reached?": {
    es: "Llamada número 1, ¿alcanzada?"
  },
  "Call #2 Not Reached - Left Message": {
    es: "Llamada # 2 no alcanzada - Dejar mensaje"
  },
  "Call #2 Reached?": {
    es: "Llamada número 2, ¿alcanzada?"
  },
  "Call #3 Not Reached - Left Message": {
    es: "Llamada # 3 no alcanzada - Dejar mensaje"
  },
  "Call #3 Reached?": {
    es: "Llamada número 3, ¿alcanzada?"
  },
  "Call Action": {
    es: "Atención telefónica"
  },
  "Call to Reschedule": {
    es: "Lamar para reprogramar"
  },
  "Call-Back to Schedule": {
    es: "Regresar la llamada en el horario acordado"
  },
  "Call-back Time": {
    es: "Tiempo de devolución de llamada"
  },
  "Call-back": {
    es: "Llamar de vuelta"
  },
  Calls: {
    es: "Llamados"
  },
  Cameras: {
    es: "Cámaras"
  },
  Cancel: {
    es: "Cancelar"
  },
  "Card CVV": {
    es: "Numero de seguridad"
  },
  "Card Number": {
    es: "Número de tarjeta"
  },
  "Change B-File Creator": {
    es: "Cambiar al Creador del Archivo-B"
  },
  "Change Creator": {
    es: "Cambiar Creador"
  },
  "Change Credit Card": {
    es: "CAMBIAR TARJETA DE CRÉDITO"
  },
  "Change Credit Card/Billing": {
    es: "CAMBIAR TARJETA DE CRÉDITO/FACTURACIÓN"
  },
  "Change Payment Method": {
    es: "CAMBIAR MÉTODO DE PAGO"
  },
  Children: {
    es: "Hijos/as"
  },
  "Choose A Financial Specialist": {
    es: "Elija un especialista financiero"
  },
  "Choose A Specialist": {
    es: "Seleccione Un Especialista"
  },
  "Choose File": {
    es: "Seleccione un  Archivo"
  },
  "Choose a Period": {
    es: "Seleccionar un Período"
  },
  "Choose a Period:": {
    es: "Seleccione un Período:"
  },
  City: {
    es: "Ciudad  "
  },
  "City/State/Zip": {
    es: "Ciudad / Estado/ Código Postal"
  },
  "Classic Car": {
    es: "Automóvil clásico"
  },
  "Click here to download the formatted template": {
    es: "Apriete aqui para bajar el modelo formateado"
  },
  "Clothing and Accessories Stores": {
    es: "Tiendas de Ropa y Accesorios"
  },
  "Coin collections": {
    es: "Colección de monedas"
  },
  "Company Name": {
    es: "Nombre de la compañía"
  },
  "Complete Not Sold": {
    es: "Venta no completada"
  },
  "Complete Sold": {
    es: "Venta completa"
  },
  Complete: {
    es: "Completa"
  },
  Condominium: {
    es: "Condominio"
  },
  "Confirmed liability conversation acknowledged by customer:": {
    es: "Conversación sobre riesgos confirmada admitida por el cliente:"
  },
  "Confirmed liability conversation not acknowledged by customer:": {
    es: "Conversación sobre riesgos no confirmada admitida por el cliente:"
  },
  "Continuing the Journey as the Trusted Advisor": {
    es: "Continuar el viaje como el asesor de confianza"
  },
  "Continuing the Relationship as the Trusted Advisor": {
    es: "Continuando la Relación como Asesor Confiable"
  },
  "Contracted Services (e.g. Locksmiths, Furniture Installers,  Commercial Cleaning, etc.)": {
    es:
      "Servicios por contrato (por ej., cerrajeros, instaladores de muebles, lavanderías, etc.)"
  },
  "Contractor Services": {
    es: "Servicios por Contrato"
  },
  "Create A New B-File": {
    es: "Crear un nuevo Archivo-B"
  },
  "Create B-File": {
    es: "CREAR ARCHIVO-B"
  },
  "Created by": {
    es: "Creado por"
  },
  "Created by:": {
    es: "Creado por:"
  },
  "Cross Sell Opportunities": {
    es: "Oportunidades de Pólizas Adicionales"
  },
  "Cross Sell Opportunities:": {
    es: "Oportunidades de Pólizas Adicionales :"
  },
  "Cross Sell Opportunity": {
    es: "Nuevas oportunidades para ofrecer"
  },
  "Cross-Sell are Mandatory": {
    es: "Pólizas adicionales son Obligatorias"
  },
  "Current Carrier": {
    es: "Proveedor actual"
  },
  "Customer Declined Email Request": {
    es: "Solicitud de correo electrónico rechazada por el cliente"
  },
  "Customer Home": {
    es: "Domicilio del cliente"
  },
  "Customer Information": {
    es: "Información del Cliente"
  },
  "Customer Name": {
    es: "Nombre del Cliente"
  },
  "Customer Phone": {
    es: "Teléfono del Cliente"
  },
  "DELETE B-FILE": {
    es: "SUPRIMIR B-FILE"
  },
  DELETE: {
    es: "SUPRIMIR"
  },
  DENY: {
    es: "NEGAR"
  },
  DEPOSIT: {
    es: "DEPÓSITO"
  },
  "DESIGNATE VOB FINANCIAL ADVISOR": {
    es: "DDESIGNAR un CONSEJERO FINANCIERO CV"
  },
  "DID YOU KNOW": {
    es: "¿SABÍA USTED QUE?"
  },
  "DISABLE USER": {
    es: "INHABILITAR USUARIO"
  },
  "DOB is Mandatory": {
    es: "Fecha de Nacimiento es Obligatorio"
  },
  "DOB is Mandatory.": {
    es: "Fecha de nacimiento es Mandatorio."
  },
  DOB: {
    es: "Fecha de nacimiento"
  },
  "DON'T TRANSFER B-FILES": {
    es: "NO TRANSFIERA B-FILES"
  },
  Dashboard: {
    es: "Plataforma"
  },
  "Date to On-Board Customer": {
    es: "Fecha para cerrar trato con cliente"
  },
  Date: {
    es: "Fecha"
  },
  "Date…": {
    es: "Fecha…"
  },
  Day: {
    es: "Día"
  },
  December: {
    es: "Diciembre"
  },
  "Delete B-File": {
    es: "SUPRIMIR B-FILE"
  },
  Delete: {
    es: "SUPRIMIR"
  },
  "Deleted B-Files": {
    es: "Archivos-B borrados"
  },
  "Deleted BFiles": {
    es: "B-Files Borrados"
  },
  "Deleted Bfiles": {
    es: "Bfiles Suprimidas"
  },
  "Delivered at": {
    es: "Entregado a"
  },
  Deny: {
    es: "NEGAR"
  },
  Deposit: {
    es: "DEPÓSITO"
  },
  "Designate Customer as VIP": {
    es: "Catalogar cliente como VIP"
  },
  "Designate VOB Financial Advisor": {
    es: "Designar un Consejero Financiero CV"
  },
  Details: {
    es: "Detalles"
  },
  "Did I catch you at an OK time?": {
    es: "Es momento oportuno?"
  },
  "Did Not Renew": {
    es: "No Fueron Renovados"
  },
  "Director of Training and Education": {
    es: "Director de Entrenamiento y Educación"
  },
  "Disable User": {
    es: "INHABILITAR USUARIO"
  },
  Disabled: {
    es: "Discapcitado"
  },
  "Do you own any secondary vehicles? (e.g. ATV's, RV's, Motorcycles, Boats, etc.)and, if so, what is the total value of these vehicles?": {
    es:
      "Es propietario de un segundo vehículo? (ejemplo Vehículos de todo terreno, Vehículos Recreacionales, Motocicletas, Botes, etc) y si es así, cuál es el valor total de estos vehículos?"
  },
  "Drug Stores and Pharmacies": {
    es: "Farmacias"
  },
  "Due Date": {
    es: "Fecha de vencimiento"
  },
  "EA Philosophy": {
    es: "Filosofía AP"
  },
  "EDIT / UPDATE": {
    es: "EDITAR / ACTUALIZAR"
  },
  "EDIT USER": {
    es: "EDITAR USUARIO"
  },
  EDIT: {
    es: "EDITAR"
  },
  "EFS Philosophy": {
    es: "Filosofía EFS"
  },
  EFS: {
    es: "EFS"
  },
  "ENABLE USER": {
    es: "HABILITAR al USUARIO"
  },
  ENABLE: {
    es: "HABILITAR"
  },
  "EXP Month": {
    es: "VENCE Mes"
  },
  "EXP Month…": {
    es: "VENCE Mes…"
  },
  "EXP Year": {
    es: "VENCE Año"
  },
  "EXP Year…": {
    es: "VENCE Año…"
  },
  "Edit / Update": {
    es: "EDITAR / ACTUALIZAR"
  },
  "Edit User": {
    es: "EDITAR USUARIO"
  },
  Edit: {
    es: "Editar"
  },
  "Effective Date": {
    es: "Fecha Efectiva"
  },
  "Effective Date:": {
    es: "Fecha Efectiva:"
  },
  "Effective Date…": {
    es: "Fecha Efectiva…"
  },
  "Email Address": {
    es: "Correo electrónico /e-mail"
  },
  Email: {
    es: "Correo electrónico"
  },
  "Emerging Adult": {
    es: "Adulto emeregente"
  },
  Employed: {
    es: "Empleo"
  },
  "Employer Name:": {
    es: "Nombre del Empleador:"
  },
  Employer: {
    es: "Empleador"
  },
  Employment: {
    es: "Empleo"
  },
  "Enable Reward Program": {
    es: "Habilitar programa de recompensas"
  },
  "Enable S&P Index for this Customer": {
    es: "Autorizar Índice S&P para este Cliente"
  },
  "Enable User": {
    es: "HABILITAR al USUARIO"
  },
  Enable: {
    es: "HABILITAR"
  },
  "End Date": {
    es: "Fecha de término"
  },
  "Equal To": {
    es: "Igual a"
  },
  "Established Household": {
    es: "Propiedad establecida"
  },
  "Estimated Production Credit": {
    es: "Producción de crédito estimada"
  },
  "Estimated Produ…": {
    es: "Producción estimada"
  },
  "Estimated Value": {
    es: "Valor estimado"
  },
  "Active Call Date": {
    es: "Fecha de vencimiento"
  },
  "Explain Limits": {
    es: "Explicar lites"
  },
  "Families on the verge of entering their prime earning years, generally with roots in the community and children in their tweens/teens.": {
    es:
      "Familias a punto de entrar en su primeros años de ingresos, generalmente con raíces en la comunidad y los niños en sus preadolescentes y adolescentes."
  },
  "Families that may have adult children, the lead of retirement on the horizon, and care for aging parents.": {
    es:
      "Las familias que pueden tener hijos adultos, la perspectiva de la jubilación en el horizonte, y el cuidado de los padres ancianos."
  },
  "Features & Fixes": {
    es: "Características y Arreglos"
  },
  February: {
    es: "Febrero"
  },
  File: {
    es: "Archivo"
  },
  "Filter by Agency Owner": {
    es: "Filtrar por Dueño de Agencia"
  },
  "Filter by Agency": {
    es: "Filtrado por la Agencia"
  },
  "Filter by EA": {
    es: "Filtrar por EA"
  },
  "Fin Appts Made By:": {
    es: "Citas Financieras Hechas Por:"
  },
  "Financial Appt. Scheduled": {
    es: "Cita para financiamiento. Programada."
  },
  "Financial Assets": {
    es: "Activos financieros"
  },
  "Financial Conversation": {
    es: "Conversación financiera"
  },
  "Financial Products Sold": {
    es: "Productos Financieros Vendidos"
  },
  "Financial Specialist": {
    es: "Especialista Financiero"
  },
  "Financial Specialist:": {
    es: "Especialista financiero:"
  },
  Financial: {
    es: "Financiero"
  },
  "Fine arts": {
    es: "Arte"
  },
  Firearms: {
    es: "Armas"
  },
  "First Name is Mandatory.": {
    es: "Nombre es Mandatorio."
  },
  "First Name": {
    es: "Nombre"
  },
  Florists: {
    es: "Florerías"
  },
  "Food and Beverage Stores": {
    es: "Tiendas de Comida y Bebidas"
  },
  "Forward to Financial Specialist to Schedule a Life/Retirement Appointment": {
    es:
      "Enviar  Especialista Financiero para programar una cita de Seguro de Vida / de Jubilación"
  },
  Fri: {
    es: "Viernse"
  },
  Friday: {
    es: "Viernes"
  },
  From: {
    es: "De"
  },
  "From...": {
    es: "De..."
  },
  "Funeral Homes": {
    es: "Funerarías"
  },
  Furs: {
    es: "Pieles"
  },
  "Game Name": {
    es: "Nombre del juego"
  },
  "Gamification Notifications": {
    es: "Notificaciones de Juego"
  },
  Gamification: {
    es: "Gamificación"
  },
  "Get Value": {
    es: "OBTENER EL VALOR"
  },
  "Gift Card": {
    es: "Tarjeta de regalo "
  },
  "Give feedback or ask for help": {
    es: "Quejas o sugerencias"
  },
  "Golf Cart": {
    es: "Carro de golf"
  },
  "Golfer's equipment": {
    es: "Equipo de golf"
  },
  "Greater Than": {
    es: "Mayor que"
  },
  "Health Care and Medical Offices": {
    es: "Conmsultorios Médicos y Centros de Salud"
  },
  'Hello Mr./Mrs. Charlie, this is "Test EA Test EA" calling from Allstate Insurance.': {
    es:
      'Hola Sr  Charlie, esto es "Prueba EA Prueba EA" llamando desde seguros Allstate'
  },
  "Hello Mr./Mrs. customer_name, this is efs_name calling from agency_name Agency. I'm the Agency's Financial Specialist. How are you today?": {
    es:
      'Hola Sr./Sra. "{{customer_name}}", esta es "{{efs_name}}" llamando de la "{{agency_name}}". Soy el Especialista Financiero de la Agencia. Cómo esta usted hoy?'
  },
  "Hello Mr./Mrs. customer_name. This is ea_name calling from agency_name. How are you today?": {
    es:
      'Hola Sr./Sra. "{{customer_name}}". Esto es "{{ea_name}}" llamando de la "{{agency_name}}". Cómo está usted hoy?'
  },
  "Hello Mr./Mrs. customer_name. This is ea_name calling from agency_name.": {
    es:
      'Hola Sr./Sra. "{{customer_name}}". Esto es "{{ea_name}}" llamando de la "{{agency_name}}".'
  },
  "Help & Suggestions": {
    es: "Ayuda y Sugerencias"
  },
  "Here at our Agency we do things differently for your policy renewal. We are going to review your existing policy to make sure you qualify for all of our discounts and that your coverage satisfies your protection needs. We always start this conversation by reviewing your LIABILITY LIMITS.": {
    es:
      "Aquí en nuestra agencia hacemos las cosas en forma diferente con respecto a la renovación de su póliza. Revisaremos su póliza actual para asegurarnos que se califica para todos nuertos descuentos y que su cobertura satisface sus necesidades de protección. Siempre comenzamos esta conversación sus LíMITES DE RIESGOS."
  },
  "Hint: Look at the profile and determine if you want to keep pursuing this customer.": {
    es:
      "Sugerencia: Mire el perfil y determine si desea seguir buscando a este cliente."
  },
  "Home Goods Stores": {
    es: "Tiendas de Productos Caseros"
  },
  "Home Ploicy Not Renewed": {
    es: "Póliza de Seguro de Vivienda No Renovado"
  },
  "Home Policy Sold fields are mandatory.": {
    es: "Póliza de casa Vendida / Renovada es Mandatorio."
  },
  "Home Policy Sold is Mandatory": {
    es: "Póliza de Seguro de Vivienda Vendido es Obligatorio"
  },
  "Home Policy Sold/Renewed": {
    es: "Póliza de casa Vendida / Renovada"
  },
  Home: {
    es: "Domicilio"
  },
  Homemaker: {
    es: "Ama de casa"
  },
  "Household Income": {
    es: "Salario del propietario"
  },
  "Household Income:": {
    es: "Ingreso del hogar"
  },
  "Household Total Assets": {
    es: "Activos totales del hogar"
  },
  "Households w/P&C Cross Sell Opportunities": {
    es: "Oportunidad de ofrecer nuevas coberturas"
  },
  "How long have you worked there?": {
    es: "¿Cuánto tiempo trabajó allí?"
  },
  "How many?": {
    es: "¿Cuántos?"
  },
  "How much do you want to put into your account?": {
    es: "Cuánto dinero quiere depositar en su cuenta?"
  },
  'How would you rate "{lsp_name}" and your agency experience on a scale from 1-10?': {
    es:
      'Cómo calificaría usted "{lsp_name}" y la experiencia con la agencia en una escala del 1-10?'
  },
  "I believe you spoke with {ea_name} from our agency the other day and he/she wanted me to contact you to schedule a time for us to get together and perform a complimentary Life Insurance and Retirement review.": {
    es:
      'Creo que el otro día habló con "{ea_name}" de nuestra agencia y él/ella quería que lo contacte para programar una cita para reunirnos y realizar la revisión gratuita de los Seguros de Vida y Jubilación.'
  },
  "I believe you spoke with {ea_name} from our agency the other day and he/she wanted me to contact you to schedule a time for us to get together and perform a complimentary Life Insurance review.": {
    es:
      'Creo que el otro día habló con "{ea_name}" de nuestra agencia y él/ella quería que lo contacte para programar una cita para reunirnos y realizar la revisión gratuita del Seguro de Vida.'
  },
  "I believe you spoke with {ea_name} from our agency the other day and he/she wanted me to contact you to schedule a time for us to get together and perform a complimentary Retirement review.": {
    es:
      'Creo que el otro día habló con "{ea_name}" de nuestra agencia y él/ella quería que lo contacte para programar una cita para reunirnos y realizar la revisión gratuita del Seguro de Jubilación.'
  },
  "I offer Agency Owner specific training on Monday &amp; Wednesday every week. Please register": {
    es:
      "Ofrezco entrenamiento específico para Deños/as de Agenciaslos lunes y miércoles de cada semana. Favor de registrarse"
  },
  "I offer Financial Specialist specific training on Wednesday &amp; Friday every week. Please register": {
    es:
      " Ofrezco entrenamiento específico para Especialistas Financieros los miércoles & viernes de cada semana. Favor de registrarse"
  },
  "I wanted to make sure you understand that if a premium rate increase occurs, my agency is committed to always making sure you have the proper coverages at the best rate. Rates on your policy are not a reflection of our agency.": {
    es:
      "Quería asegurarme que usted entiende que si ocurre  un aumento en  la tarifa de la prima , mi agencia está comprometida a asegurarnos siempre que usted tenga las coberturas  correctas con la mejor tasa. Tassa en su póliza no son una reflección de nuestra agencia."
  },
  "I'd like to schedule a time for us to get together and perform your complimentary Financial Services review. Do you need an Evening appointment or does the Day work for you?": {
    es:
      "Me gustaría programar una cita para reunirnos y hacer el reviso de Servicios Financieros gratuito. Necesita una cita por la noche o está libre en el día?'"
  },
  "INVITE AGENCY SALES STAFF": {
    es: "INVITAR A EQUIPO DE VENTAS DE UNA AGENCIA"
  },
  "INVITE USER": {
    es: "INVITAR USUARIO"
  },
  "IRA's": {
    es: "IRA's "
  },
  "Identifying if your customer has a mortgage is good time to see if he or she owns Life Insurance.": {
    es:
      "Identificando si el cliente tiene una hipoteca, es una buena oportunidad de ver si él o ella tienen Seguro de Vida."
  },
  "If a college student is not taking a car to school, it’s a poor choice to remove the child from an existing auto policy to reduce costs.": {
    es:
      "Si un estudiante universitario no lleva un auto al colegio, no es una buena decisión el remover el hijo de una póliza de auto existente para reducir costos."
  },
  "If the customer is in need of immediate assistance and wants to speak with someone regarding financial planning or life & retirement options, you can bypass the Welcome call and send the B-File customer directly to the Financial Specialist.": {
    es:
      "Si el cliente tiene necesidad de atención inmediata y quiere hablar con alguien acerca de sus opciones de planes financieros para seguros de vida y de jubilación, por favor omita la Llamada de Bienvenida y envíe al cliente de Archivos-B directamente con un especialista financiero."
  },
  "If the student is not taking a car to school, it is not the right choice to remove the child from an existing auto policy to reduce costs.": {
    es:
      "Si el estudiante no está conduciendo un auto a la escuela, no es una buena decisión quitar a ese hijo/a de la poliza de seguro de autos para reducir costos."
  },
  "If you do not have sufficient liability coverage to protect your assets, your assets may be subject to being liened, garnished or attached in a lawsuit.": {
    es:
      "Si  no tiene cobertura de riesgo sufuciente para proteger sus bienes, sus bienes pueden ser retenidos, embargados y adjuntados en un juicio."
  },
  'If you want to change your password hit "Forgot my Password" on the login screen to change.': {
    es:
      'Si desea cambiar su contraseña, marque "Olvdé mi Contraseña" en la pantalla de Ingreso'
  },
  "Immediate Attention for Financial Review": {
    es: "Atención Inmediata para Revisión Financiera"
  },
  "Immediate Life and Retirement Opportunities": {
    es: "Oportunidades inmediatas de Vida y Jubilación"
  },
  Immediately: {
    es: "Inmediatamente"
  },
  '"In the near future, you will be asked to complete a survey from the insurance company. We want you to be able to report that you are completely satisfied with our agency and your experience."': {
    es:
      '"En los próximos días, se le pedirá que complete una encuesta de la compañía de seguros, Queremos que usted pueda reportar que está completamente satisfecho con nuestra agencia y con sus servicios."'
  },
  "Inactive Users": {
    es: "Usuarios inactivos"
  },
  "Individual Retirement Plan that is usually funded by rolling over a retirement plan from a previous employer.  Traditional IRA's are taxable when funds are taken out during retirement.  Roth IRA's are not taxable when funds are taken out at retirement.": {
    es:
      "Un Plan de Jubilación Individual que es fundado usualmente transferiendo un plan de jubilación de un empleador anterior.Los IRA's tradicionales son  sujetos a impuesto cuando los fondos son retirados durante la jubilación. Roth IRA's no son sujetos a impuestos cuando los fondos son retirados durante la jubilación."
  },
  "Individual Retirement Plan that is usually funded by rolling over a retirement plan from a previous employer. Traditional IRA's are taxable when funds are taken out during retirement. Roth IRA's are not taxable when funds are taken out at retirement.": {
    es:
      "Un Plan de Jubilación Individual que está normalmente fundado en trasladar un plan de jubilación de un empleado previo. Los fondos tradicionales de IRA’s pagan impuestos cuando los fondos se extraen durante el jubilación. Los fondos Roth de IRA’s no pagan impuestos cuando los fondos se extraen durante el jubilación."
  },
  "Insurance Score": {
    es: "Resultados del Seguro"
  },
  "Insurance contracts that people use for guaranteed income in the future.": {
    es:
      "Contratos de seguro que la gente usa como un pago garantizado en el futuro."
  },
  "Intro Script": {
    es: "Escrito de introducción"
  },
  "Introduction to Financial Services": {
    es: "Introducción a los Servicios Financieros"
  },
  "Invite Agency Sales Staff (LSP's)": {
    es: "Invitar al Equipo de Ventas de la Agencio  (LSP’s)"
  },
  "Invite Attendee": {
    es: "Invitar al Participante"
  },
  "Invite User": {
    es: "INVITAR USUARIO"
  },
  "Invited Users": {
    es: "Usuarios invitados"
  },
  "Items Sold In Household": {
    es: "Artículos vendidos en el hogar"
  },
  "Items Sold": {
    es: "Productos vendidos"
  },
  "I’m looking forward to working with you and your partner(s). Please let me know if there is": {
    es:
      " Será un gusto trabajar con ustedes y con su(s) compañero(s). Por favor, háganme saber si hay algo "
  },
  "I’m looking forward to working with you and your staff. Please let me know if there is anything I": {
    es:
      "Será un gusto trabajar con ustedes y con su equipo. Por favor, háganme saber si hay algo en lo que pueda"
  },
  January: {
    es: "Enero"
  },
  Jewelry: {
    es: "Joyas"
  },
  July: {
    es: "Julio"
  },
  June: {
    es: "Junio"
  },
  "Just a quick note to introduce myself and say thank you for signing up for B-File. I’m sensitive": {
    es:
      "Sólo una pequeña nota para presentarme y agradecerles que se registraron para un Archivo-B. Estoy consciente"
  },
  "Just a quick note to introduce myself. I’m sensitive to your busy schedule but wanted to reach": {
    es:
      "Sólo una pequeña nota para presentarme. Estoy consciente de su horario tan ocupado y quisiera  "
  },
  "LINK FINANCIAL SPECIALIST": {
    es: "ENLACE CON ESPECIALISTA FINANCIERO"
  },
  "LINK USER": {
    es: "ENLACE CON USUARIO"
  },
  "LSP (Life Licensed)": {
    es: "LSP (Licencia de vida)"
  },
  "LSP (Onboarding & Life Licensed)": {
    es: "LSP (A bordo + Licencia de vida)"
  },
  "LSP (Onboarding)": {
    es: "LSP (A bordo)"
  },
  "LSP Philosophy": {
    es: "Filosofía LSP"
  },
  "LSP Rating and ACES Reminder": {
    es: "   Clasificación LSO y Recordatorio ACES "
  },
  "LSP Rating": {
    es: "Indice LSP"
  },
  LSP: {
    es: "LSP"
  },
  "LSP’s will receive a link to schedule LSP training once they create a password and log in to their": {
    es:
      "LSP’s  recibirán un enlace (link) para programar un entrenamiento LSP una vez que hayan creado una contraseña y e ingreso (password and login) para su"
  },
  Landlord: {
    es: "Propietario de Negocio"
  },
  Language: {
    es: "Idioma"
  },
  "Last Logged In": {
    es: "Última vez Conectado"
  },
  "Last Logged In:": {
    es: "Última vez conectado:"
  },
  "Last Name is Mandatory.": {
    es: "Apellido es Mandatorio."
  },
  "Last Name": {
    es: "Apellido(s)"
  },
  "Last Updated": {
    es: "Última actualización"
  },
  "Laundry Services": {
    es: "Lavanderías"
  },
  Leaderboard: {
    es: "Tabla de clasificación"
  },
  Leads: {
    es: "Oportunidad"
  },
  "Left Message": {
    es: "Mensaje dejado"
  },
  "Legal Services": {
    es: "Servicios Legales"
  },
  "Less Than": {
    es: "Menor que"
  },
  "Liability Acknowledgement": {
    es: "Reconocimiento de responsabilidad"
  },
  "Liability Animation": {
    es: "Animación sobre Deudas / Obligaciones"
  },
  "Liability limits are usually never discussed and many of your customers may have inadequate coverage.": {
    es:
      "Por lo general, los límites de riesgo nunca se discuten y muchos de nuestros clientes podrian no tener cobertura adecuada."
  },
  "Liability limits are usually never discussed and most of your customers are not properly covered.": {
    es:
      "Los Límites de Endeudameinto casi nunca se discuten y la mayor de los clientes no esán propiamente cubiertos"
  },
  Liability: {
    es: "Deudas"
  },
  "Life & Asset": {
    es: "Vida y activos"
  },
  "Life & Retirement Call Attempts (Not Reached)": {
    es: "Llamadas para Seguros de Vida / Jubilación (no rechazadas)"
  },
  "Life & Retirement Call Reached": {
    es: "Llamadas para Seguros de Vida / Jubilación (rechazadas)"
  },
  "Life & Retirement Conversation": {
    es: "Conversación sobre Vida & Jubilación"
  },
  "Life & Retirement Introductions": {
    es: "Introducciones a Seuros de Vida y de Jubilación"
  },
  "Life Insurance & Retirement": {
    es: "Seguro de Vida y Jubilación"
  },
  "Life Insurance Conversation": {
    es: "Conversación sobre el seguro de vida"
  },
  "Life Insurance Owned": {
    es: "Propietario de Seguro de Vida"
  },
  "Life Insurance Owned:": {
    es: "Número de Seguros de Vida:"
  },
  "Life Insurance": {
    es: "Seguro de Vida"
  },
  "Life Licensed": {
    es: "Licencia de vida"
  },
  "Life Opportunities": {
    es: "Oportunidadews de Seguro de Vida"
  },
  "Life Stage": {
    es: "Etapas de la vida"
  },
  Life: {
    es: "Vida"
  },
  "Life/Financial Sale": {
    es: "Venta de Vida/Financiera"
  },
  "Life/Retirement Opportunity": {
    es: "Oportunidades para mi Seguro de Vida y de Jubilación"
  },
  "Life/Retirement": {
    es: "Vida/Jubilación"
  },
  "Link Financial Specialist": {
    es: "ENLACE A ESPECIALISTA FINANCIERO"
  },
  "Link Financial Specialst": {
    es: "Conectar Especialista Financiero"
  },
  "Link User": {
    es: "CONECTAR USUARIO"
  },
  "Linked Agency Owner": {
    es: " Ligar a EA's ?"
  },
  "Linked EA's": {
    es: " Ligar a EA's ?"
  },
  Logout: {
    es: "Salir"
  },
  "MFG Home": {
    es: "Casa Prefabricada"
  },
  MM: {
    es: "Mes"
  },
  "Manage Participants": {
    es: "Administrar participantes"
  },
  "Manage Users": {
    es: "Administrar Usuarios"
  },
  March: {
    es: "Marzo"
  },
  "Mature Household": {
    es: "Casa madura"
  },
  May: {
    es: "Mayo"
  },
  "Mike Hallahan": {
    es: "Mike Hallahan"
  },
  Mobile: {
    es: "Teléfono móvil"
  },
  Mon: {
    es: "Lunes"
  },
  Monday: {
    es: "Lunes"
  },
  Months: {
    es: "Meses"
  },
  "Mortgage Loan Brokers": {
    es: "Préstamos de Hipotecas"
  },
  Mortgage: {
    es: "Hipoteca"
  },
  "Motor Vehicle Parts Dealers": {
    es: "Distribuidores de Partes de Vehículos Motorizados"
  },
  Motorcycle: {
    es: "Motocicleta"
  },
  "Musical instruments": {
    es: "Instrumentos musicales"
  },
  "My B-Files": {
    es: "Mis B-Files"
  },
  "My Calls / Agency Calls": {
    es: "Mis llamadas / Llamadas de la Agencia"
  },
  "My Life & Retirement Opportunities": {
    es: "Oportunidades para mi Seguro de Vida y de Jubilación"
  },
  "My Life and/or Retirement Activity": {
    es: "Mi Actividad de Vida y/o Jubilación"
  },
  "My agency offers a referral gift card program. Do I have your permission to send you an email that allows you to redeem a {giftcard_amount} gift card for making friends and family referrals to our agency?": {
    es:
      "Mi agencia ofrece un programa de targeta de regalo por referencia. Me permite usted que le mande un correo electrónico que le permita redimir una targeta de regalo de {giftcard_amount} por recomendar anuestra agencia a familiares y amigos?"
  },
  "My notes indicate": {
    es: "Mis notas indican:"
  },
  "My notes indicate:": {
    es: "Mis notas indican:"
  },
  NEXT: {
    es: "PRÓXIMO"
  },
  Name: {
    es: "Nombre"
  },
  "Needs Attention": {
    es: "Necesita atneción"
  },
  "New B-File": {
    es: "Siguiente Archivo-B"
  },
  "New Bfile": {
    es: "Siguiente Archivo-B"
  },
  "New Customer": {
    es: "Cliente nuevo"
  },
  "New Password": {
    es: "Nueva Contraseña"
  },
  "New Referrals": {
    es: "Referencais nuevas"
  },
  Next: {
    es: "SIGUIENTE"
  },
  "No Answer": {
    es: "Sin respuesta"
  },
  "No B-Files Found": {
    es: "Número de Archivos-B encontrados"
  },
  "No Bfiles Found.": {
    es: "No se Bfiles."
  },
  "No Invites Found": {
    es: "No se han encontrado invitaciones"
  },
  "No Item Found": {
    es: "No se hallaron artículos"
  },
  "No Items Found": {
    es: "No se hallaron artículos"
  },
  "No Mortgage": {
    es: "Sin Hipoteca"
  },
  "No Referrals Found": {
    es: "Ningunas Remiciones Descubiertas"
  },
  "No Referrals Found.": {
    es: "Ningunas Remiciones Descubiertas"
  },
  "No Sale Archive": {
    es: "Archivo de Sin Ventas"
  },
  "No Sale/Archive": {
    es: "SIN VENTA / ARCHIVO"
  },
  "No email address provided": {
    es: "No hay correo electrónico proporcionado"
  },
  "No file chosen": {
    es: "Ningun Archivo Elegido"
  },
  "No invited users.": {
    es: "Usuarios no invitados"
  },
  "No problem. When is a good time for me to give you a buzz back?": {
    es: "No hay problema. Cuándo sería hora conveniente para volver a llamarlo?"
  },
  "No sale archive": {
    es: "Archivo de No Ventas"
  },
  No: {
    es: "No"
  },
  None: {
    es: "Ninguno"
  },
  "Not Available": {
    es: "No disponible"
  },
  "Not Complete": {
    es: "Incompleto"
  },
  "Not Interested": {
    es: "No le interesa"
  },
  "Not Quoted": {
    es: "No Citado"
  },
  "Not Reached": {
    es: "no alcanzada"
  },
  "Not Sold": {
    es: "No vendido/a"
  },
  Note: {
    es: "Nota"
  },
  Notes: {
    es: "Notas"
  },
  "Notes…": {
    es: "Notas…"
  },
  "Note…": {
    es: "Nota…"
  },
  Notifications: {
    es: "Notificaciones"
  },
  November: {
    es: "Noviembre"
  },
  "Number of Children": {
    es: "Número de Hijos"
  },
  "Number of Children:": {
    es: "Número de hijos/as:"
  },
  "Number of Tango cards issued to the customers": {
    es: "Número de Targetas Tango emitidas a los clientes"
  },
  October: {
    es: "Octubre"
  },
  "Off Road": {
    es: "Vehículo de todo Terreno"
  },
  "Offer 30-day Review": {
    es: "Ofrecer revisión de 30 días"
  },
  Office: {
    es: "Oficina"
  },
  "On the phone, without visual cues, it is essential to pause for at least three seconds after the client has spoken to avoid cutting them off.": {
    es:
      "En el teléfono, sin señales visuales, es esencial pausar por lo menos tres segundos después de que el cliente ha hablado para evitar cortarlos."
  },
  "On-Boarder:": {
    es: "Coordinador"
  },
  Onboarding: {
    es: "A bordo"
  },
  "Once your free trial has expired, you will be billed a one-time set up fee of $199.95, and your Annual": {
    es:
      "Una vez que el tiempo de prueba haya expirado, se le cobrará por una sola vez el costo de $199.95 y su primer"
  },
  "Once your free trial has expired, you will be billed a one-time set up fee of $199.95, and your first": {
    es:
      "Una vez que el tiempo de prueba haya expirado, se le cobrará por una sola vez el costo de $199.95 y su primer"
  },
  "Order History": {
    es: "Encargar Historia"
  },
  Other: {
    es: "Otros"
  },
  "Our agency's commitment is to become your trusted advisor. I'd like to schedule a meeting at your convenience to introduce myself and educate you on Life Insurance Strategies.": {
    es:
      "El compromiso de nuestra agencia es convertirse en su asesor de confianza. Me gustaría programar una reunión a su conveniencia para presentarme y educarle sobre las estrategias de seguro de vida"
  },
  "Our agency's commitment is to become your trusted advisor. I'd like to schedule a meeting at your convenience to introduce myself and educate you on Life Insurance and Retirement Strategies.": {
    es:
      "El compromiso de nuestra agencia es convertirse en su asesor de confianza. Me gustaría programar una reunión a su conveniencia para presentarme y educarle en el seguro de vida y estrategias de jubilación."
  },
  "Our agency's commitment is to become your trusted advisor. I'd like to schedule a meeting at your convenience to introduce myself and educate you on Retirement Strategies.": {
    es:
      "El compromiso de nuestra agencia es convertirse en su asesor de confianza. Me gustaría programar una reunión a su conveniencia para presentarme y educarle sobre estrategias de jubilación."
  },
  "Outcome of Life and Retirement Appointment (Step 3)": {
    es: "Resultado de la cita para Seguro de Vida / Jubilación (Paso 3)"
  },
  "Outcome of Life and Retirement Appointment": {
    es: "Resultado de la cita para Seguro de Vida / Jubilación"
  },
  "Ownership interest in a business": {
    es: "Participación en un negocio"
  },
  "P&C Cross Sell Opportunities": {
    es: "P&C Oportunidades de venta de nuevos productos"
  },
  "P&C Leads": {
    es: "P&C guías"
  },
  "P&C Referrals Leads": {
    es: "Referencias"
  },
  "P&C Renewal Conversation": {
    es: "P&C Conversación para renovar seguro"
  },
  "P&C Reviews": {
    es: "P&C Revisiones"
  },
  "P&C": {
    es: "P&C"
  },
  "Paid Referrals": {
    es: "Remisiones Pagas"
  },
  "Participant Name": {
    es: "Nombre del participante"
  },
  "Pending Opportunities": {
    es: "Oportunidades pendientes"
  },
  "Pending Payouts": {
    es: "Pagos pendientes"
  },
  "Pending Referrals": {
    es: "Referencias pendientes"
  },
  "Personal Info": {
    es: "Información personal"
  },
  "Personal Information": {
    es: "Infromación Personal"
  },
  "Personal Property": {
    es: "Propiedad Personal"
  },
  "Personal Services (e.g. Pet Groomers)": {
    es: "Servicios personales (por ej., cuidadores de mascotas)"
  },
  Personal: {
    es: "Personal"
  },
  "Phone Number": {
    es: "Número de teléfono"
  },
  "Phone is Mandatory.": {
    es: "Número de teléfono es Mandatorio."
  },
  Phone: {
    es: "Teléfono"
  },
  Photography: {
    es: "Fotografía"
  },
  "Please fill all fields": {
    es: "Por favor rellene todos los campos"
  },
  "Please fill all fields.": {
    es: "Por favor complete todas las preguntas"
  },
  "Please fill in all fields": {
    es: "Por favor rellene todos los campos"
  },
  "Please open our agency referral email when you receive it and follow the instructions to get started.": {
    es:
      "Por favor, abra nuestro correo electrónico de referencia de agencia cuando lo reciba y siga las instrucciones para empezar."
  },
  "Please select an agent": {
    es: "Por favor seleccione un agente"
  },
  "Policy Questions": {
    es: "Preguntas sobre Póliza"
  },
  Previous: {
    es: "PREVIO"
  },
  "Primary & secondary vehicles have value and can be exposed as assets in a judgment.": {
    es:
      "Vehículos primarios y secundarios tienen valor, y pueden ser presentados como bienes en un juicio."
  },
  "Primary Home": {
    es: "Domicilo establecido"
  },
  "Primary Mortgage Balance": {
    es: "Saldo de la Hipoteca Primaria"
  },
  "Priority Status": {
    es: "Estado de prioirdad"
  },
  "Product Sold": {
    es: "Producto vendido"
  },
  Product: {
    es: "Producto"
  },
  "Product...": {
    es: "Producto..."
  },
  "Products Not Sold": {
    es: "Productos no vendidos"
  },
  "Products Sold": {
    es: "Productos vendidos"
  },
  Profile: {
    es: "Perfil"
  },
  'Protecting What You "EARN"': {
    es: 'Protegiendo lo que usted "GANA"'
  },
  'Protecting What You "SAVE"': {
    es: 'Protegiendo lo que usted "AHORRA"'
  },
  "Quality Rating": {
    es: "Clasificación de calidad"
  },
  "Intelligence Link Calc.": {
    es: "Calculador de Riesgos"
  },
  "RE-ACTIVATE": {
    es: "Reactivar"
  },
  RECOMMENDED: {
    es: "RECOMENDADO/A"
  },
  "RELOAD YOUR ACCOUNT": {
    es: "RECARGAR SU CUENTA"
  },
  "RESEND EMAIL": {
    es: "REENVIAR CORREO ELECTRÓNICO"
  },
  RESEND: {
    es: "REENVIAR"
  },
  RESET: {
    es: "REESTABLECER"
  },
  RV: {
    es: "Vehículo Recreacional"
  },
  "Rate Conversation": {
    es: "Califique la Conversación"
  },
  "Rates Do Not Apply to Survey": {
    es: "Tasas No Se Aplican a la Encuesta"
  },
  "Re-Confirm Desire for Life and Retirement Appointment (Step 2)": {
    es: "Re-Confirmar Deseo para Cita de Vida y Jubilación (Paso 2)"
  },
  "Re-Confirm Desire for Life and Retirement Appointment": {
    es: "Confirmar cita para vida y jubilación"
  },
  "Re-activate": {
    es: "RE-ACTIVAR"
  },
  "Re-balance / Diversification Conversation": {
    es: "Conversación de balance / Diversificación"
  },
  Reached: {
    es: "Alcanzada"
  },
  "Real Estate Brokers": {
    es: "Agentes de Bienes y Raíces"
  },
  "Received by Financial or Life Specialist": {
    es: "Recibido por el Especialista Financiero o de Vida"
  },
  Recipient: {
    es: "Destinatario"
  },
  "Recommended Liability Limits": {
    es: "Límites de endeudameinto recomentados"
  },
  Recommended: {
    es: "Recomendado"
  },
  "Recommended: The next step in the B-File process is to send this customer over to the Agency Owner or designated agent in charge of thanking the customer for his/her business, and introducing him/her to a life & retirement specialist.": {
    es:
      "Recomendación: El siguiente paso en el proceso de Archivos-B es enviar al cliente al Dueño/a de la Agencia o al agente designado que esté a cargo de agradecer al cliente por su interés, y presentarlo/a con un/a especialista en seguros de vida & jubilación."
  },
  "Referral / Social Media": {
    es: "Referencia / Medios sociales"
  },
  "Referral Payouts": {
    es: "Pagos de referencia"
  },
  Referral: {
    es: "Remisión"
  },
  Referrals: {
    es: "Referencias"
  },
  Refresh: {
    es: "Refrescar"
  },
  Regards: {
    es: "Saludos"
  },
  "Regards,": {
    es: "Saludos,"
  },
  "Reload Your Account": {
    es: "RECARGAR SU CUENTA"
  },
  "Reload your account": {
    es: "Recargar su cuenta"
  },
  "Remaining Retirement Dollars": {
    es: "Monto de dólares de Jubilación Restantes"
  },
  "Remaining Retirement Opportunities": {
    es: "Oportunidades de Jubilación Restantes"
  },
  "Remaining Retirement Opportunities:": {
    es: "Oportunidades Restantes de Jubilación:"
  },
  "Remind customer their proof of insurance is in policy packet.": {
    es:
      "Recordar al cliente que su prueba de seguro está en el paquete de su poliza"
  },
  "Remind the customer his/her proof of insurance is in the policy packet.": {
    es:
      "Recuerde al cliente que su prueba de seguro está en el paquete de pólizas."
  },
  "Reminder Notifications": {
    es: "Notificaciones Recordatorias"
  },
  Remove: {
    es: "Retirar"
  },
  "Renewal Customer": {
    es: "Cliente que renueva"
  },
  Renewal: {
    es: "Renovar"
  },
  Renewals: {
    es: "Renovaciones"
  },
  Rent: {
    es: "Renta / Alquiler"
  },
  "Rental Services": {
    es: "Servicios de Alquiler / Renta"
  },
  "Repair and Maintenance": {
    es: "Reparaciones y Mantenimiento"
  },
  Reporting: {
    es: "Reportes"
  },
  "Reschedule Date": {
    es: "Reprogramar la cita"
  },
  "Resend Email": {
    es: "REENVIAR CORREO ELECTRÓNICO"
  },
  "Resend Invite": {
    es: "Reenviar invitar"
  },
  Resend: {
    es: "REENVIAR"
  },
  Reset: {
    es: "REESTABLECER"
  },
  Results: {
    es: "Resultados"
  },
  "Retired customers who want to enjoy life and leave their legacy.": {
    es: "Clientes jubilados que quieren disfrutar de la vida y dejar su legado."
  },
  Retired: {
    es: "Retirado"
  },
  Retiree: {
    es: "Jubilado/a"
  },
  "Retirement $": {
    es: "Dinero de jubilación"
  },
  "Retirement $'s Uncovered": {
    es: "Monto $'s de Jubilación Descubiertos"
  },
  "Retirement Conversation": {
    es: "Conversación de Jubilación"
  },
  "Retirement Dollars": {
    es: "Dólares de Jubilación"
  },
  "Retirement Opportunities": {
    es: "Oportunidades de Seguro de Jubilación"
  },
  "Retirement Opps": {
    es: "Oportunidades para Seguros de Jubilación"
  },
  "Retirement Plan": {
    es: "Plan de Jubilación"
  },
  "Retirement plan is required.": {
    es: "Plan de jubilacion es requerido"
  },
  "Reward Program": {
    es: "Programa de recompensas"
  },
  "Reward System": {
    es: "Sistema de recompensas"
  },
  "Intelligence Link": {
    es: "Tabulador de riesgos"
  },
  "S&P 500": {
    es: "S&P 500"
  },
  "S&P Reporting": {
    es: "Informes S&P"
  },
  "SAVE & CLOSE": {
    es: "GUARDAR Y CERRAR"
  },
  "SAVE FOR LATER": {
    es: "RESERVAR PARA DESPUÉS"
  },
  SAVE: {
    es: "SALVAR"
  },
  "SELECT FINANCIAL SPECIALIST": {
    es: "SELECCIONAR ESPECIALISTA FINANCIERO"
  },
  "SEND FOR WELCOME CALL": {
    es: "PEDIR LLAMADA DE BIENVENIDA"
  },
  "SEND REFERRAL LINK": {
    es: "MANDAR ENLACE A REFERENCIA"
  },
  "Send Referral Link": {
    es: "MANDAR ENLACE A REFERENCIA"
  },
  "SEND TANGO GIFT CARD": {
    es: 'Enviar una tarjeta de regalo "TANGO"'
  },
  "SEND TO VIRTUAL ON-BOARD": {
    es: "ENVIAR a COORDINADOR VIRTUAL"
  },
  "SEND TO WELCOME/THANK YOU CALL": {
    es: "ENVIAR A LLAMADA DE BIENVENIDA/GRACIAS"
  },
  "SEND VIA IMMEDIATE ATTENTION FOR FINANCIAL REVIEW": {
    es: "ENVÍE VÍA ATENCIÓN INMEDIATA PARA REVISIÓN FINANCIERA"
  },
  SEND: {
    es: "ENVIAR"
  },
  SHOW: {
    es: "Mostrar"
  },
  SUBMIT: {
    es: "MANDAR"
  },
  "Sale Notifications": {
    es: "Notificaciones de Venta"
  },
  Sat: {
    es: "Sábado"
  },
  Saturday: {
    es: "Sábado"
  },
  "Save & Close": {
    es: "GUARDAR Y CERRAR"
  },
  "Save for Later": {
    es: "GUARDAR PARA DESPUÉS"
  },
  Save: {
    es: "Guardar"
  },
  "Saved for Later": {
    es: "Guardado para después"
  },
  "Saved for laters": {
    es: "Guardado para después"
  },
  "Savings Acc'ts": {
    es: "Cuentas de Ahorro"
  },
  "Savings Accounts": {
    es: "Cuenta de Ahorros "
  },
  "Schedule Appointment for Financial Specialist Now": {
    es: "Programar una cita con un Especialista Financiero ahora"
  },
  "Schedule Appointment": {
    es: "Programar una cita"
  },
  "Schedule a better time to Discuss Agency Life/Retirement Process with me": {
    es:
      "Programar otra ocasión para conversar el proceso de la Agencia sobre un seguro de Vida / de Jubilación conmigo"
  },
  "Scheduled personal property protects valuable items that are out of the ordinary and need to carry separate coverage to ensure that their full value is covered in the event of a claim.": {
    es:
      "La Lista de Propiedad personal protege articúlos de valor que son fuera de lo común y necesitan cobertura separada para asegurarse que su valor total sea recuperado en el evento de un reclamo."
  },
  "Scheduling Appointment": {
    es: "Programación de la cita"
  },
  "Scheduling the Appointment": {
    es: "Programación de la cita"
  },
  Search: {
    en: "Search",
    es: "Búsqueda"
  },
  "Search…": {
    es: "Buscar"
  },
  "Secondary Home": {
    es: "Segunda casa / prpiedad"
  },
  "Secondary Properties": {
    es: "Propiedades secundarias"
  },
  "Security Code (CVV2, CVC2, or CID)": {
    es: "Código de Seguridad (CVV2, CVC2, o CID )"
  },
  "Security Code": {
    es: "Código de Seguridad"
  },
  "See Profile Data": {
    es: "Vease Datos de Perfil"
  },
  "Select Agency Owner": {
    es: "Seleccionar Dueño de Agencia"
  },
  "Select Default Date": {
    es: "Seleccione Fecha cuándo automáticamente va a"
  },
  "Select EA": {
    es: "Seleccionar EA"
  },
  "Select EFS": {
    es: "Seleccionar EFS"
  },
  "Select Financial Product": {
    es: "Seleccione Producto Financiero"
  },
  "Select Financial Specialist": {
    es: "Seleccionar EFS"
  },
  "Select Jobs": {
    es: "Seleccionar Trabajos"
  },
  "Select LSP": {
    es: "Seleccionar LSP"
  },
  "Select Timezone": {
    es: "Selecciona la zona horaria"
  },
  Select: {
    es: "Seleccionar"
  },
  "Select...": {
    es: "Seleccionar..."
  },
  "Select…": {
    es: "Seleccione…"
  },
  "Self Storage": {
    es: "Almacenamiento"
  },
  Print: {
    es: "Imprimir"
  },
  "Send B-File to EAgent/Print": {
    es: "Enviar Archivo-B a Agente E / Imprimir"
  },
  "Send B-File to Eagent/Print": {
    es: "Enviar B-File a Eagente/Imprimir"
  },
  "Send B-File": {
    es: "Enviar B-File"
  },
  "Send Bfile": {
    es: "Enviar Bfile"
  },
  "Send For Thank You Call": {
    es: "Enviar para Llamadas de Agradecimiento/Bienvenida"
  },
  "Send For Thank You/Welcome Call": {
    es: "Pedir Llamada de Agradecimiento / Bienvenida"
  },
  "Send Gift Card Request": {
    es: "Enviar solicitud de tarjeta de regalo"
  },
  "Send Tango Gift Card": {
    es: 'Enviar una tarjeta de regalo "TANGO"'
  },
  "Send a Gift Card": {
    es: "Enviar una tarjeta de regalo"
  },
  "Send a Gift": {
    es: "Enviar un regalo"
  },
  "Send to Life/Retirement Specialist for Immediate Attention": {
    es:
      "Enviar a un especialista en Seguros de Vida/ Jubilación para atención inmediata"
  },
  "Send to On-Boarder for Welcome Call": {
    es: "Enviar al inicio para llamada de bienvenida"
  },
  "Send to Virtual On-Boarder": {
    es: "Enviar a Coordinador Virtual"
  },
  "Send to Virtual On-boarder": {
    es: "Enviar a Coordinador Virtual"
  },
  "Send to Welcome/Thank You Call": {
    es: "ENVIAR A LLAMADA DE BIENVENIDA/GRACIAS"
  },
  "Send us a message": {
    es: "Envnos un mensaje"
  },
  "Send via Immediate Attention for Financial Review": {
    es: "ENVÍE VÍA ATENCIÓN INMEDIATA PARA REVISIÓN FINANCIERA"
  },
  Send: {
    es: "ENVIAR"
  },
  "Sent for Financial Conversation": {
    es: "Enviado para Conversación Financiera"
  },
  "Sent for Financial Conversation:": {
    es: "Enviado para Conversación Financiera"
  },
  "Sent for Immediate Attention": {
    es: "Enviar para atención inmediata"
  },
  "Sent for Introduction to Financial Specialist": {
    es: "Enviado para Introducción del Especialista Financiero"
  },
  "Sent for On-Boarding": {
    es: "Enviar a Coordinador"
  },
  "Sent for Virtual On-Boarding": {
    es: "Enviado para Coordinación Virtual"
  },
  "Sent for Welcome/Thank You Call": {
    es: "Enviar para Bienvenida / Llamada de agradecimiento"
  },
  "Sent for Welcome/Thank You Calls": {
    es: "Enviados para llamdos de Bienvenida/ Agradecimiento"
  },
  "Sent to EFS": {
    es: "Enviados a Especialista Financiero"
  },
  "Sent to EFS/LLSP/SUB": {
    es: "Enviados a Especialista Financiero"
  },
  "Sent to Financial Specialist": {
    es: "Enviados a Especialista Financiero"
  },
  "Sent to Financial or Life Specialist": {
    es: "Enviar a un especialista en Seguros de Vida o en Financiamiento"
  },
  "Sent to Financial": {
    es: "Enviado a Departamento de Finanzas"
  },
  "Sent to Life/Financial Specialist": {
    es: "Enviado al área de Vida / Especialista Financiero"
  },
  "Sent to On-Boarding": {
    es: "Enviado a Coordinación"
  },
  "Sent to Virtual Onboarder": {
    es: "Enviados a Coordinador Virtual"
  },
  Sent: {
    es: "Enviado"
  },
  September: {
    es: "Septiembre"
  },
  "Show Calls": {
    es: "Mostrar Llamados"
  },
  "Show Pending B-Files": {
    es: "Mostrar Archivos-B pendientes"
  },
  "Show Pending BFiles": {
    es: "Mostrar Archivos-B pendientes"
  },
  "Show Respect": {
    es: "Muestra respeto"
  },
  "Show all": {
    es: "Mostrar todos"
  },
  Show: {
    es: "Mostrar"
  },
  Silverware: {
    es: "Cubiertos"
  },
  "No Follow-Up": {
    es: "Omitir llamada de bienvenida & introducción financiera"
  },
  Snowmobile: {
    es: "Motonieve"
  },
  "Social Media": {
    es: "Medios Sociales"
  },
  Sold: {
    es: "Vendido/a"
  },
  "Sold/Renewed": {
    es: "Vendidos /Renovados"
  },
  "Sports equipment": {
    es: "Equipo de deportes"
  },
  "Spouse First Name": {
    es: "Nombre de su esposo/a"
  },
  "Spouse Last Name": {
    es: "Apellido de su esposo/a"
  },
  "Spouse's DOB": {
    es: "Fecha de nacimiento de su esposo/a"
  },
  "Stamp collections": {
    es: "Colección de estampillas"
  },
  Standard: {
    es: "Estándard"
  },
  "Start Date": {
    es: "Fecha de inicio"
  },
  "Starting the Relationship as the Trusted Advisor": {
    es: "Inicio de la relación como el Asesor de confianza"
  },
  State: {
    es: "Estado"
  },
  Status: {
    es: "Estatus"
  },
  Step: {
    es: "Paso"
  },
  "Strategic Opportunities": {
    es: "Oportunidades estratégicas"
  },
  "Subject: Welcome to B-File. Your journey starts here!": {
    es: "Tema: Bienvenidos a los Archivos-B. Su viaje empieza aquí:"
  },
  "Subject: Welcome to B-File.": {
    es: "Tema: Bienvenidos a los Archivos-B"
  },
  Submit: {
    es: "MANDAR"
  },
  Sun: {
    es: "Domingo"
  },
  Sunday: {
    es: "Domingo"
  },
  Surveyors: {
    es: "Topógrafo"
  },
  "TELL US A STORY ABOUT THIS CUSTOMER": {
    es: "DÍGANOS UNA HISTORIA ACERCA DE SU CLIENTE"
  },
  "TRANSFER B-FILE": {
    es: "TRANSFERIR B-FILE"
  },
  "TRANSFER OWNERSHIP": {
    es: "TRANSFERIR PROPIEDAD"
  },
  "Tango Card": {
    es: "Targeta Tango"
  },
  "Tango Gift Cards": {
    es: 'Tarjeta de regalo "TANGO"'
  },
  "Tango card balance": {
    es: "Saldo de Targetas de Tango"
  },
  Target: {
    es: "Objetivo"
  },
  "Tell Us a Story About This Customer": {
    es: "Díganos una historia sobre este cliente"
  },
  "Tell Us a Story": {
    es: "Díganos una Historia"
  },
  "Tell Us a Story…": {
    es: "Díganos una Historia…"
  },
  Term: {
    es: "Duración"
  },
  "Thank You/Intro to Life & Retirement Calls Attempted": {
    es: "Gracias/Llamados Atentados de Introducción de Vida y Jubilación"
  },
  "Thank You/Intro to Life & Retirement Calls": {
    es: "Gracias/Llamados de Introducción de Vida y Jubilación"
  },
  "Thank You/Life & Retirement Call Attempts (Not Reached)": {
    es:
      "Llamadas de Agradecimiento para Seguros de Vida / Jubilación (rechazadas)"
  },
  "Thank You/Life & Retirement Call Reached": {
    es:
      "Llamadas de Agradecimiento para Seguros de Vida / Jubilación (no rechazadas)"
  },
  "Thank You/Life & Retirement Call": {
    es: "LLamadas de Agradecimiento para Seguros de Vida / Jubilación"
  },
  "Thank You/Life & Retirement Calls Attempted": {
    es: "Gracias / Llamadas de Vida y Jubilación Intentadas"
  },
  "Thank you again for subscribing to the B-File System.": {
    es: "Gracias, de nuevo, por suscribirse al systema de Archivos-B"
  },
  "The equity in your home may be at risk in the event of a liability lawsuit.": {
    es:
      "La plusvalía de su casa puede estar en riesgo en caso de una demanda por endeudamiento"
  },
  "The equity in your home may be exposed to a liability lawsuit.": {
    es: "La equidad de su hogar puede ser expuesta a un juicio de riesgo."
  },
  "The next step in the B-File process is to send this customer over to the Agency Owner or designated agent in charge of thanking the customer for his/her business, and introducing him/her to a life & retirement specialist.": {
    es:
      "El siguiente paso en el proceso de B-File es mandar a este cliente al Dueño de la Agencia o agente designado a cargo  de agradecerle al cliente/a por su negocio, y presentarle a él/ella al especialista de vida y jubilación."
  },
  "The primary vehicles plus any secondary vehicles have value and can be exposed as an asset in a judgment.": {
    es:
      "Los vehículos primarios más algunos vehículos secundarios tienen valor y pueden ser expuestos como un bien en un juicio."
  },
  "This Month": {
    es: "ESTE MES"
  },
  Thu: {
    es: "Jueves"
  },
  Thursday: {
    es: "Jueves"
  },
  Timezone: {
    es: "Huso Horario"
  },
  "Timezone*": {
    es: "Huso Horario*"
  },
  "To confirm, you have selected our Annual Subscription.": {
    es: "Para confirmar, usted ha seleccionado nuestra Suscripcinual"
  },
  "To confirm, you have selected our Monthly Subscription.": {
    es: "Pora confirmar que usted ha elegido unaSuscripción mensual"
  },
  "To login go to …": {
    es: "Para ingresar (login) a. . ."
  },
  To: {
    es: "Para"
  },
  "To...": {
    es: "Para..."
  },
  "Total Additional Mortgage Balances": {
    es: "Saldos Totales de Hipotecas Adicionales"
  },
  "Total Additional Mortgage Balances:": {
    es: "Balance del total de Hipotecas adicionales:"
  },
  "Total Amount Paid": {
    es: "Cuenta total pagada"
  },
  "Total Dollars": {
    es: "Dólares Totales"
  },
  "Total Household Assets": {
    es: "Total de bienes del hogar"
  },
  "Total IPS": {
    es: "Total IPS"
  },
  "Total Opportunities Uncovered": {
    es: "Total de oportunidades no cubiertas"
  },
  "Total Retirement $'s Uncovered": {
    es: "Total de Jubilación $'s Revelado"
  },
  "Total Retirement $'s Uncovered:": {
    es: "Monto  Total $'s de Jubilación Descubierto:"
  },
  "Total Value of Asset Acc'ts.:": {
    es: "Valor total de las cuentas de activos:"
  },
  '"Total value of the secondary vehicles?"': {
    es: '"Valor total de los vehículos secundarios?"'
  },
  Total: {
    es: "Total"
  },
  "Total:": {
    es: "Total:"
  },
  Training: {
    es: "Formación"
  },
  "Transfer B-File": {
    es: "Transferir Archivo-B"
  },
  "Transfer B-Files": {
    es: "Transferir Archivos-B"
  },
  "Transfer Ownership": {
    es: "TRANSFERIR PROPIEDAD"
  },
  "Travel Agents": {
    es: "Agentes de Viaje"
  },
  "Trigger 1: Completed B-File (Send for Welcome Call or via Immediate Attention).": {
    es:
      "Meta 1: Archivo-B completo (Enviar por una Llamada de Bienvenida o vía Atención Inmediata"
  },
  "Trigger 2: During Welcome Call, the creator rating is 9 or greater.": {
    es:
      "Meta 2:  Durante la Llamada de Bienvenida, la calificación del creador es de 9 o más."
  },
  "Trigger 3: A Financial Appointment was made (During the Welcome Call or Life/Financial conversation).": {
    es:
      "Meta 3: Una Cita para Financiación se ha hecho (Durante la Llamada de Bienvenida  o en la conversación sobre Seguro de Vida o Financiamiento"
  },
  Tue: {
    es: "Martes"
  },
  Tuesday: {
    es: "Martes"
  },
  "Twenty somethings who are just grasping the basics of finances and insurance.": {
    es:
      "Veinteañeros (20 años o más) que están aprendiendo las bases de finanzas y de los seguros."
  },
  Type: {
    es: "Tipo",
    en: "Type"
  },
  Types: {
    es: "Tipos"
  },
  "Types:": {
    es: "Tipos:"
  },
  "UNLINK USER": {
    es: "DESENLAZAR (UNLINK) USUARIO"
  },
  "UPDATE GIFT CARD AMOUNT": {
    es: "ACTUALIZAR MONTO de TARJETA de REGALO"
  },
  "Update Gift Card Amount": {
    es: "ACTUALIZAR MONTO de TARJETA de REGALO"
  },
  UPLOAD: {
    es: "Subir"
  },
  "Umbrella Opportunities": {
    es: "Oportunidades Paraguas"
  },
  "Umbrella Sold": {
    es: "Paraguas Vendido"
  },
  Umbrella: {
    es: "Cobertura"
  },
  "Umbrellas Sold": {
    es: "Coberturas contratadas"
  },
  "Umbrellas Uncovered (Not Sold)": {
    es: "Coberturas no contratadas"
  },
  Umbrellas: {
    es: "Cobertura"
  },
  "Under 1 Year": {
    es: "Menos de un año"
  },
  Unemployed: {
    es: "Desempleado"
  },
  "Universal/Whole-Life": {
    es: "Universal / Para toda la vida"
  },
  "Unlink User": {
    es: "DESENLAZAR (UNLINK) USUARIO"
  },
  Unlink: {
    es: "Desenlazar (unlink)"
  },
  "Update Amount to Give on the gift card": {
    es: "Actualizar Monto para Dar en la Tarjeta de Regalo"
  },
  "Update B-File": {
    es: "ACTUALIZAR ARCHIVO-B"
  },
  "Update Billing": {
    es: "Actualizar la Facturación"
  },
  "Update Password": {
    es: "Poner al día su Contraseña"
  },
  "Update gift card amount": {
    es: "ACTUALIZAR MONTO de TARJETA de REGALO"
  },
  Update: {
    es: "Actualizar"
  },
  "Upload Customers": {
    es: "Subir Clientes"
  },
  Upload: {
    es: "Subir"
  },
  Urgent: {
    es: "Urgente"
  },
  "Use the Intelligence Link to determine your proper limits of liability.": {
    es:
      "Use la Calcualdora que determina riesgos para establecer sus propios límites de deuda "
  },
  "User Type": {
    es: "Tipo de usuario"
  },
  User: {
    es: "Usuario"
  },
  Users: {
    es: "Usuario"
  },
  "Using this function will bypass the B-File process and automatically put this customer in a renewal status. This is only recommended if the customer is a long term customer and has all his/her opportunities with the agency already.": {
    es:
      "Usando esta función, evitará el proceso B-File y automáticamente coloca al cliente en un estatus de renovación. Ésto sólo se recomuienda si el cliente es a plazo largo y ya tiene todas sus oportunidades con la agencia."
  },
  "VIP Reporting": {
    es: "Informes VIP"
  },
  VIP: {
    es: "VIP"
  },
  "VOB Financial Advisor": {
    es: "CV Consejero Financiero"
  },
  "Vacant Property": {
    es: "Propiedad vacante"
  },
  "Value : No Mortgage": {
    es: "Valor: Sin Hipoteca"
  },
  "Value for Trigger 1": {
    es: "Valor de la Meta # 1"
  },
  "Value for Trigger 2": {
    es: "Valor de la Meta # 2"
  },
  "Value for Trigger 3": {
    es: "Valor de la meta # 3"
  },
  Value: {
    es: "Evaluar"
  },
  Vehicles: {
    es: "Vehulos"
  },
  "Verify email address": {
    es: "Confirme su dirección de correo electrónico"
  },
  Veterinarians: {
    es: "Veterinarios"
  },
  Videos: {
    es: "Videos"
  },
  "View Results": {
    es: "Visita de resultados"
  },
  View: {
    es: "Ver"
  },
  "Virtual On-Board Stats (Completed)": {
    es: "Estadísticas Virtuales de Coordinación (Completas)"
  },
  "Virtual On-Boarder:": {
    es: "Coordinador Virtual"
  },
  "Virtual Onboard Capabilities": {
    es: "Capacidades Virtuales de Coordinación"
  },
  Watercraft: {
    es: "Embarcación"
  },
  Wed: {
    es: "Miércoles"
  },
  Wednesday: {
    es: "Miércoles"
  },
  Week: {
    es: "Semana"
  },
  "Welcome/Thank You Call to Customer (Step 1)": {
    es: "Lamada de Bienvenida/Agradecimiento al Cliente (PASO 1)"
  },
  "Welcome/Thank You Call to Customer": {
    es: "Bienvenida / Llamada de agradecimiento al Cliente"
  },
  "Welcome/Thank You Calls Attempted": {
    es: "Bienvenida /  Llamadas de agradecimiento intentadas"
  },
  "Welcome/Thank You Calls Default Date": {
    es: "Bienvenida/ llamada de agradecimiento a la fecha establecida"
  },
  "Welcome/Thank You Calls": {
    es: "Bienvenida / Llamada de agradecimiento"
  },
  "What did you learn about this customer": {
    es: "¿Qué aprendiste sobre este cliente?"
  },
  "What did you learn about this customer?": {
    es: '"¿Qué aprendió acerca de este cliente?"'
  },
  "What's your current employment status?": {
    es: "Cuál es su estado de empleo?"
  },
  '"When do you want to meet with {financial_name}?"': {
    es: '"Cuando quiere reunirse con {financial_name}?"'
  },
  "When do you want to meet with": {
    es: "Cuando quiere reunirse con"
  },
  "When would you like to schedule your appointment?": {
    es: "¿Cuándo desea programar su cita?"
  },
  "Where will the appointment take place?": {
    es: "¿Dónde tendrá lugar la cita?"
  },
  "Who Created": {
    es: "Quién creó "
  },
  "Who Referred": {
    es: "Quién lo/a refirió"
  },
  "Wholesale Apparel": {
    es: "Venta al Mayor de Ropa "
  },
  "Wholesale Drugs": {
    es: "Venta al Mayor de Medicinas "
  },
  "Wholesale Food": {
    es: "Venta al Mayor de Alimentos "
  },
  "Wholesale Hardware": {
    es: "Venta al Mayor de Herramientas (Ferreterías)"
  },
  "Wholesale Home and Office": {
    es: "Venta al Mayor de Productos para la Casa y Para la Oficina"
  },
  "Wholesale Medical Goods": {
    es: " Venta al Mayor de Productos Médicos "
  },
  "Wholesale Sporting Goods": {
    es: "Venta al Mayor de Productos Deportivos"
  },
  Winner: {
    es: "Ganador"
  },
  Winners: {
    es: "Ganadores"
  },
  "Worked there:": {
    es: "Trabajó allí:"
  },
  "Would you prefer a day or evening appointment?": {
    es: "¿Prefiere una cita durante el día o en la tarde?"
  },
  YYYY: {
    es: "Año"
  },
  Year: {
    es: "Año"
  },
  Yes: {
    es: "Sí"
  },
  "You have taken an important first step in integrating LIFE &amp; RETIREMENT into your P&amp;C world.": {
    es:
      "Usted ha tomado un primer paso importante para integrar su Seguro de VIDa & JUBILACIÓN en su mundo de P&C."
  },
  "You've tried 3 attempts to contact this customer. Do you want to keep trying?": {
    es:
      "Has hecho 3 intentos para contactar a este cliente. ¿Quieres seguir intentándolo?"
  },
  "Young Household": {
    es: "Familia joven"
  },
  "Young families facing a world of firsts – first home, first child – and the responsibilities they bring.": {
    es:
      "Familias jóvenes que enfrentan un mundo de primeras - primer hogar, primer niño - y las responsabilidades que traen."
  },
  "Your PW is: *Allstate1": {
    es: "Su Contraseña es: *Allstate1"
  },
  "Your login email is: @allstate.com": {
    es: "Su correo  de ingreso (login e-mail) es: @allstate.com"
  },
  "Your team will automatically receive an email once they have created passwords, so they can register": {
    es:
      "Su equipo recibirá un correo automáticamente y le mandarán otro correo una vez que hallan creado sontraseñas, para qu ellos puedan registrar"
  },
  "Zip Code": {
    es: "Codigo Postal"
  },
  Zipcode: {
    es: "Código Postal"
  },
  '"Did I catch you at an OK time?"': {
    es: '"¿Tiene usted tiempo para conversar?'
  },
  '"Did user_name commit to offering a personal insurance review 30 days before renewal?"': {
    es:
      '"El "{{user_name}}" se encomendó a ofrecerle una revisión de seguro personal 30 días antes de la renovación?"'
  },
  '"Did user_name explain to you in detail your liability limits and accuately determine your asset protection needs when creating your policy?"': {
    es:
      '"Le ha explicado a usted  el "{{user_name}}" en detalle sus límites de riesgo y determinado con precisión sus necesidades de protección de bienes al momento de crear su póliza?"'
  },
  '"Do you have a mortgage and, if so, what is the mortgage balance?"': {
    es:
      '"¿Tiene usted una hipoteca y, si es así, cual es el balance de su hipoteca?"'
  },
  '"Do you have a mortgage and, if so, what\'s the remaining mortgage balance?"': {
    es:
      '"Tiene una hipoteca y, si es así, cuál es el balance restante de la hipoteca?"'
  },
  '"Do you have any questions regarding your policies that I may be able to help you with?"': {
    es: '"¿Tiene alguna pregunta con respecto a sus políticas?"'
  },
  '"Do you or anyone in the household have a retirement plan?(e.g. a 401k, 403b, etc) and, if so, what is the approximate value of the retirement plan?"': {
    es:
      '"¿Tiene usted o alguien de su familia un plan de jubilación? (por ejemplo: un pan 401k, 403b, etc.) y, si es así, cuál es el valor aproximado de ese plan de jubilación? "'
  },
  '"Do you or anyone in the household own any of the following type of accounts?"': {
    es:
      '¿"Posee usted o alguien de su familia cualquiera de las siguientes cuentas?"'
  },
  '"Do you own any additional properties outside your primary residence(e.g. rentals, 2nd home, condo, vacant land, etc.) and, if so, what kind and how much are they worth?"': {
    es:
      '"¿Posee usted alguna propiedad adicional a su residencia primaria (por ejemplo:  renta, segunda casa, condominio, terreno, etc.) y, si es así, qué tipo y cuál es su valor?'
  },
  '"Do you own any properties in addition to your primary residence (e.g. rentals, 2nd home, condo, vacant land, etc.) and, if so, what kind of properties and what is their total market value?"': {
    es:
      '"Es dueño de otras propiedades además de residencia principal(por ejemplo propiedades rentadas, una  segunda casa, condominio, terreno vacío, etc.) y si es así, qué tipo de propiedades son y cuál es  su valor de mercado total?"'
  },
  "\"Do you own any secondary vehicles? (e.g. ATV's, RV's, Motorcycles, Boats, etc.)?\"": {
    es:
      "¿Posee usted algún otro tipo de vehículo? (por ejemplo: motocicleta, barco, etc.) y si , en cuanto están valuados?"
  },
  '"Do you own your primary home and, if so, what is the approximate value?"': {
    es:
      "Es dueño de su hogar principal y, si es así, cual es el valor aproximado?'"
  },
  '"Do you own your primary home?"': {
    es: '"¿Posee usted un domicilio establecido?"'
  },
  '"Does anyone in the household own life insurance to pay for final expenses or debt repayment and, if so, what type of policy is it and what is the total death benefit?"': {
    es:
      '"¿Alguien de su familia posee un seguro de vida para pagar los costos finales o los costos de endeudamiento y, si es así, qué tipo de poliza es y cuál es el total de los beneficios tras el fallecimiento?'
  },
  '"Does anyone within the household have an ownership interest in a business?"': {
    es: '"¿Cuál es el valor en el mercado de estas propiedades secundarias?"'
  },
  '"Does the customer want a certain call time back for Introduction?"': {
    es:
      '"¿Desea el/la cliente que se le llame otra vez a un tiempo determinado para hacerle una Presentación?"'
  },
  '"False"': {
    es: '"Falso"'
  },
  "\"Finally, I'd like to introduce you to the next step in our agency's process. We offer all of our valued customers a complimentary review of your Life Insurance and Retirement needs.\"": {
    es:
      '"Finalmente, quisiera presentarle el próximo paso en el proceso de nuestra agencia. Ofrecemos a todos nuetros estimados clientes un reviso gratuito de sus necesidades sobre Seguro de Vida y Jubilación."'
  },
  "\"Finally, I'd like to introduce you to the next step in our agency's process. We offer all of our valued customers a complimentary review of your Life Insurance needs.\"": {
    es:
      '"Finalmente, me gustaría introducirlo al siguiente paso en el proceso de la agencia. Ofrecemos a todos nuestros estimados clientes un reviso gratuito de sus necesidades sobre Seguro de Vida."'
  },
  "\"Finally, I'd like to introduce you to the next step in our agency's process. We offer all of our valued customers a complimentary review of your retirement needs.\"": {
    es:
      '"Finalmente, quisiera presentarle el próximo paso en el proceso de nuestra agencia. Ofrecemos a todos nuestros estimados clientes un reviso gratuito de sus necesidades de jubilación."'
  },
  '"Finally, I\'d like to introduce you to the next step in our agency’s process. We offer all of our valued customers a complimentary review of your Life Insurance and Retirement needs."': {
    es:
      '"Por último, me gustaría presentarles el siguiente paso en el proceso de nuestra agencia. Ofrecemos a todos nuestros valiosos clientes una revisión gratuita de sus necesidades de seguro de vida y jubilación."'
  },
  '"Finally, I\'d like to introduce you to the next step in our agency’s process. We offer all of our valued customers a complimentary review of your Life Insurance needs."': {
    es:
      '"Por último, me gustaría presentarles el siguiente paso en el proceso de nuestra agencia. Ofrecemos a todos nuestros valiosos clientes una revisión gratuita de sus necesidades de seguro de vida."'
  },
  '"Finally, I’d like to introduce you to the next step in our agency’s process. We offer all of our valued customers a complimentary review of your Retirement needs."': {
    es:
      '"Finalmente, quisiera presentarle a usted el siguiente paso del proceso de nuestra agencia. A todos nuestros valiosos clientes les ofrecemos una revisión complementaria de sus necesidades de Jubilación."'
  },
  '"From your file, it looks like we\'ve identified the following Life Insurance and Retirement needs you should consider when scheduling the review with us."': {
    es:
      '"Revisando su archivo, aparenta que hemos identificado las siguientes necesidades de Seguro de Vida y Jubilación que debería considerar cuando programa el  reviso con nosotros."'
  },
  '"From your file, it looks like we\'ve identified the following Life Insurance needs you should consider when scheduling the Life Insurance review with us."': {
    es:
      '"Revisando su archivo, aparenta que hemos identificado las siguientes carencias en el Seguro de Vida que debería considerar cuando planea una revisión de Seguro de Vida con nosotros."'
  },
  '"From your file, it looks like we’ve identified the following Life Insurance and Retirement needs you should consider when scheduling the review with us."': {
    es:
      '"De su archivo, parece que hemos identificado las siguientes necesidades de seguro de vida y jubilación que debe tener en cuenta al programar la revisión con nosotros."'
  },
  '"From your file, it looks like we’ve identified the following Life Insurance needs you should consider when scheduling the Life Insurance review with us."': {
    es:
      '"De su archivo, parece que hemos identificado las siguientes necesidades de seguro de vida que debe tener en cuenta al programar la revisión del seguro de vida con nosotros."'
  },
  '"Have you received your policies in the mail or in your email?"': {
    es: '"¿Ha recibido sus pólizas por correo o por correo electrónico?"'
  },
  '"Hello Mr./Mrs. {customer_name}. This is {ea_name} calling from {agency_name}. How are you today?"': {
    es:
      '"Hola señor {customer_name} . soy {ea_name} llamando desde Seguros {agency_name}. ¿Cómo estás hoy?"'
  },
  '"Household Income / Effective Date"': {
    es: "Salario del P ropietario / Fecha efectiva "
  },
  '"How many cars or trucks do you own (not lease)?"': {
    es: '"¿Cuántos automóviles o camionetas posee usted (no alquila)?"'
  },
  '"How many cars or trucks do you own (not leased)?"': {
    es: '"¿Cuántos automóviles o camionetas posee usted (no alquila)?"'
  },
  '"How many children do you have living in your home or away at college?"': {
    es:
      '"¿Cuántos hijos/as tiene viviendo en su casa o que van a la universidad?"'
  },
  '"How many employees?"': {
    es: '"¿Cuántos empleados?"'
  },
  '"I can either have our financial specialist contact you to schedule a review or I can schedule the review with you right now."': {
    es:
      '"Puedo hacer que uno de nuestros especialistas financieros se contacte con usted para programar una revisión o puedo yo mismo programar una revisión de su seguro en este mismo momento."'
  },
  '"I can either have our financial specialist contact you to schedule a review or I can schedule the review with you right now"': {
    es:
      '"Puedo hacer que uno de nuestros especialistas financieros se contacte con usted para programar una revisión o puedo yo mismo programar una revisión de su seguro en este mismo momento."'
  },
  '"I want to make sure my agency is doing a great job with valued customers like you. Did {lsp_name} do the following?" Select all that apply:': {
    es:
      '"Quiero asegurarme que mi agencia está haciendo un buen trabajo con clientes preciados como usted. La "{lsp_name}" hizo lo siguiente?" Seleccione todos los que se apliquen:'
  },
  '"I wanted to make sure you understand that if a premium rate increase occurs, my agency is committed to always making sure you have the proper coverages at the best rate.  Rates on your policy are not a reflection of our agency."': {
    es:
      '"Quería asegurarme que usted entiende que si ocurre  un aumento en  la tarifa de la prima , mi agencia está comprometida a asegurarnos siempre que usted tenga las coberturas  correctas con la mejor tasa. Tassa en su póliza no son una reflección de nuestra agencia."'
  },
  "\"I'm going to have {financial_name} reach out to you and introduce himself or herself. {financial_name} is our agency's Personal Financial Representative. This is the commitment from the agency to become your trusted advisor and the objective is not to sell you anything but educate you on options and strategies.\"": {
    es:
      '"Haré que "{financial_name}" se comunique con usted y se presente. "{financial_name}" es el Representante Financiero Personal de nuestra agencia. Este es el compromiso de la agencia de ser su consejero de confianza y el objetivo no es venderle nada sino educarlo sobre opciones y estrategias."'
  },
  '"Identifying if your customer has a mortgage is good time to see if he or she owns Life Insurance."': {
    es:
      '"Identificar sí el cliente tiene una hipoteca, porqué sería un buen momento para ver si él/ella tiene un Seguro de Vida."'
  },
  '"If you do not have sufficient insurance to protect your income, it could be exposed for garnishment in a lawsuit."': {
    es:
      '"Si usted no tiene un seguro adecuado para proteger su salario, puede esar expuesto a ser incautado en una demanda legal."'
  },
  '"If you do not have sufficient liability coverage to protect your assets, your assets may be subject to being liened, garnished or attached in a lawsuit."': {
    es:
      '"Si usted no tiene suficiente cobertura por endeudamiento para proteger sus propiedades, sus propiedades pueden estar sujetas a ser incautadas, embargadas, o ligadas a una demanda legal."'
  },
  '"If your customer is a business owner, it may be a good time to have a commercial policy conversation. Also, the business assets associated with the insured could be exposed in a liability suit."': {
    es:
      '"Si su cliente es un dueño/a de negocio, puede ser un buen momento para tener una conversación acerca de una poliza comercial. Además, las propiedades asociadas con el asegurado pueden estar expuestas a una demanda por endueudamiento."'
  },
  '"Is anyone within the household self-employed or have ownership interest in a business?"': {
    es:
      '"¿Alguien dentro del hogar trabaja por cuenta propia o es dueño de negocio?"'
  },
  '"Is there life insurance or mortgage protection insurance to pay off the remaining balance of the mortgage and, if so, what type of policy is it and what is the total death benefit payout?"': {
    es:
      '"Hay seguro de vida o seguro de protección hipotecaria para pagar el saldo restante de la hipoteca y, de ser así, qué tipo de póliza es y cuál es el pago total del beneficio por muerte?"'
  },
  '"Is there life insurance or mortgage protection insurance to pay off the remaining balance of the mortgage should something happen to you? If so, what type of policy is it and what is the total death benefit payout value?"': {
    es:
      '"Hay seguro de vida o seguro de protección hipotecaria para pagar el saldo restante de la hipoteca si algo le sucede a usted? Si es así, ¿qué tipo de póliza es y cuál es el valor total del beneficio por muerte?"'
  },
  '"Making sure your retirement assets are properly diversified according to your risk tolerance and ensuring that they are positioned correctly during market fluctuation is the purpose of the review we offer."': {
    es:
      '"Asegurarnos que sus propiedades de jubilación estén propiamente diversificadas de acuerdo al grado de riesgo establecido por usted, y asegurándonos de que estén posicionadas correctamente durante las fluctuaciones del Mercado es el propósito de la revisión que le ofrecemos."'
  },
  '"Name of the business?"': {
    es: '"¿Nombre del negocio?"'
  },
  '"No problem. When is a good time for me to call you back?"': {
    es: '"No hay problema. ¿Cuándo es un buen momento  para volverle a hablar?'
  },
  '"Other than customary items found in a home, do you have any special personal property of significant value of which we should be made aware?"': {
    es:
      "Además de los objetos usuales que se hayan en un hogar, tiene alguna propiedad personal de valor significativo que nos quisiera hacer saber?"
  },
  '"The 401K is often times the first place people go to get money when they suffer a financial hardship. Often times this financial hardship involves a liability award where the insured did not have adequate liability limits on his or her policy."': {
    es:
      '"El plan de jubilación 401K es algunas veces el primer lugar al que la gente va para obtener dinero cuando tienen una emergencia financiera.  Algunas veces la emergencia financiera incluye un juicio de endeudamiento en el que el asegurado no poseía  los límites de endeudamiento adecuados en su póliza"'
  },
  '"The equity in your home is the biggest asset most people have, and we need to protect this asset."': {
    es:
      '"La plusvalía de su casa es el mayor bien que la mayoría de las personas poseen, y nosotros necesitamos proteger ese bien."'
  },
  '"The reason for my call is to thank you for being our customer and follow up with you regarding your policies."': {
    es:
      '"La razón de mi llamada es para agradecerle por ser nuestro cliente y darle seguimiento con respecto a sus pólizas"'
  },
  '"True"': {
    es: '"Verdadero"'
  },
  '"We\'ve identified the following Retirement needs you should consider when scheduling the retirement review with us."': {
    es:
      '"Hemos identificado las siguientes necesidades que usted debe considerar para su  Jubilación cuando hagamos una cita con usted para revisar su Seguro de Jubilación."'
  },
  '"Were you treated with respect and feel my agency acted professionally?" "Did my agency handle your needs timely and accurately?"': {
    es:
      '"Fue tratado con respeto y siente que mi agencia actuó profecionalmente?" Se ha  encargado mi agencia de sus necesidades de manera oportuna y precisa?'
  },
  '"What Type(s)?"': {
    es: "Qué tipo(s)?"
  },
  '"What can we do to increase that score to a 10?"': {
    es: "¿Qué podemos hacer nosotros para subir esa calificación a 10?"
  },
  '"What is the approximate total value of these accounts?"': {
    es: '"¿Cuál es el valor total aproximado de estas cuentas?"'
  },
  '"What is the approximate value of this Personal Property?"': {
    es: "Cuál es el valor aproximado de esta Propiedad Personal?"
  },
  '"What is the death benefit?"': {
    es: '"¿Cuáles son los beneficios por fallecimiento?"'
  },
  '"What is the market value of the/these secondary property(ies)?"': {
    es: "¿Cuál es el valor en el mercado de estas propiedades secundarias? "
  },
  '"What type of business is it?"': {
    es: "¿Qué tipo de negocio es?"
  },
  '"What type of policy do you have?"': {
    es: '"¿Qué tipo de poliza tiene?"'
  },
  '"What\'s the approximate death benefit?"': {
    es: "Cuál es aproximadamente el benficio de muerte ?"
  },
  '"What\'s the approximate value of the retirement plan we need to protect?"': {
    es:
      '"Cuál es el valor aproximado del plan de jubilación que necesitamos proteger?"'
  },
  '"What\'s the approximate value of your home?"': {
    es: "¿Cuál es el valor aproximado de su casa?"
  },
  '"What\'s the total mortgage balance owed on the secondary properties?"': {
    es:
      '"Cuál es el saldo de la hipoteca total que se debe en las propiedades secundarias?"'
  },
  '"What\'s your current employment status?"': {
    es: '"Cuál es su estado de empleo?"'
  },
  '"When do you want to meet with Test EFS Test EFS?"': {
    es: '"¿Cuando quisiera conversar con un Test EFS Test EFS?"'
  },
  '"When does {customer_name} want a call back?"': {
    es: '"¿Cuándo quiere que {customer_name} vuelva a llamar?"'
  },
  '"Where did you retire from?"': {
    es: '"¿De dónde se retiró?"'
  },
  '"Which kind?"': {
    es: "¿Qué tipo?"
  },
  '"Who do you work for?"': {
    es: '"¿Para quién trabajó?"'
  },
  '"Your income and future earning potential could be exposed in a lawsuit. Our calculator defaults to a range of $25,000 - $50,000 per year, are you ok with that, or would you like me to adjust it ?"': {
    es:
      '"Su salario y sus ganancias futuras puedes estár expuestas en una demanda lega. Nuestra calculadora establece un rango de $25,000 -$ 50,000 por año, ¿es ésta una cantidad correcta o necesita ser ajustada?'
  },
  '"Your income and future earning potential could be exposed in a lawsuit. Our calculator defaults to a range of $25,000 - $50,000 per year, are you ok with that, or would you like me to adjust it?"': {
    es:
      '"Su salario y las posibles ganancias futuras pueden ser expuestos en un juicio. Nuestro calculador automáticamente va a $25.000 por año, usted está de acuerdo con esto o quisiera que yo lo ajuste?"'
  },
  '"Your survey scores will increase if you follow these scripts."': {
    es: '"Su encuesta aumentaría su calificación si siguiera estos puntos."'
  },
  "account.": {
    es: "cuenta."
  },
  "anything I can do. Also, please reply to this email with a list of names of your other EA partners": {
    es:
      "en lo que pueda ayudarlos. Asimismo, por favor contesten este correo con una lista de los nombres de otros compañeros de EA"
  },
  "been gathered.": {
    es: "han sido obtenidos."
  },
  "been sent to you.": {
    es: "que les han sido enviados"
  },
  "below and allow me to show you how you can manage your team and filter all the data that has": {
    es:
      "en la parte de abajo y permítanme mostrarles cómo pueden manejar a su equipo y filtrar todos los datos que"
  },
  "bfilesystem.com": {
    es: "bfilesystem.com"
  },
  "can do.": {
    es: "ayudarlos. "
  },
  "days late": {
    es: "dias tarde"
  },
  days: {
    es: "días"
  },
  "demo.": {
    es: "demostración"
  },
  "doing all the B-File training and want to make sure you and all your staff get registered for one": {
    es:
      "de los entrenamientos sobre el Archivo-B y quiero asegurarme de que usted y todo su equipo se registren inmediatamente para uno"
  },
  "for training. We offer training Tuesday, Wednesday &amp; Thursday, every week.": {
    es:
      "su entrenamiento. Ofrecemos entrenamientos los martes, miércoles & jueves de cada semana."
  },
  is: {
    es: "es /está"
  },
  "monthly payment of $149.95. You will be billed monthly in advance until such time as you cancel your": {
    es:
      "pago mensual de $149.95. Se le enviará mensualmente y por adelantado la cuenta hasta el momento en que usted cancele su"
  },
  "next year. You understand that there is a substantial discount over our monthly subscription rate and": {
    es:
      "el próximo año. Comprenda usted que hay un descuento substancial sobre nuestro costo de suscripción mensual y"
  },
  next: {
    es: "siguiente"
  },
  "of my webinars right away so you can take full advantage of all that B-File will do for you. Your": {
    es:
      "de los webinars, para que puedan adquirir todas las ventajas de todo lo que un Archivo-B puede hacer por ustedes.. Sus"
  },
  "our Terms of Service for further details.": {
    es: "nuestros Términos y Condiciones para mayores detalles."
  },
  "out to you and let you know what’s next. I will be doing all the B-File training and want to make": {
    es:
      "dirigirme a ustedes y comunicarles lo siguiente. Me encargaré de todo el entrenamiento de los Archivos-B y quiero asegurarme "
  },
  "please contact us before the end of your free trial to convert to a monthly subscription. Please refer to": {
    es:
      "Por favor, póngase en contacto con nosotros antes de que la prueba sin costo expire, para convetirla en una subscripción mensual. Favor de referirse a "
  },
  reporting: {
    es: "informes"
  },
  "subscription if you decide to cancel after your free trial has expired. If you do not wish to pay annually,": {
    es:
      "suscripción anual. Si usted decide cancelar después de que la prueba sin costo haya expirado. Si usted no desea pagar anualmente,"
  },
  "subscription payment of $1449.95. You will not be billed again until your subscription anniversary date": {
    es:
      "pago de suscripcin annual de $1449.95. No se le cobrarde nuevo hasta la fecha de aniversario de su subscripción"
  },
  "subscription. Please refer to our Terms of Service for further details.": {
    es:
      "subscripción. Por faror, refiérase a nuestros Teérminos y Condiciones de Servicio para obtener los detalles."
  },
  "sure you, your EA partner(s) &amp; their staff get registered for one of my webinars right away so": {
    es:
      "de que usted, su(s) compañero(s) de EA & su grupo se registren de inmediato a uno de mis webinars de manera que "
  },
  "that you would like to have on the B-File system and we will reach out to them to schedule a": {
    es:
      "con quienes quisieran compartir este sistema de Archivos-B y nos pondremos en contacto con ellos para programar una"
  },
  "therefore you are paying for an entire year in advance. Thus, no refunds will be given on the annual": {
    es:
      "por lo tanto usted esta pagando por adelantado por todo el año. Por lo tanto, no se hará ninguna reducción a la"
  },
  "to your busy schedule but wanted to reach out to you and let you know what’s next. I will be": {
    es:
      "de su horario tan ocupado y quisiera dirigirme a ustedes y comunicarles lo siguiente. Me encargaré "
  },
  where: {
    es: "donde"
  },
  "Liability limits on your policy are crucial to making sure your household is properly protected against accidents, lawsuits, and catastrophes. We do things differently at our agency & use a calculator that will suggest liability limits YOU NEED on your policy(ies). These next set of questions will help us determine whether any coverage gaps exist.": {
    es:
      "Los Límites de Endeudamiento en su póliza son cruciales para asegurar que su propiedad está adecuadamente protegida contra accidentes, demandas legales, y catástrofes. En nuestra agencias, nosotros hacemos las cosas de manera diferente & usamos una máquina calculadora que le sugerirá los límites de endeudamiento que USED NECESITA en su(s) póliza(s). El siguiente conjunto de preguntas determinará si  existe alguna falta en su cobertura."
  },
  "The correct liability limits protect your household against accidents, lawsuits, and catastrophes. I'll ask you a few questions using our agency's RISK ASSESSMENT CALCULATOR to identify any coverage gaps and make sure I don't miss any discounts.": {
    es:
      "Los límites de riesgo correctos protegen su hogar contra accidentes, juicios, y catástrofes. Le preguntaré algunas preguntas usando el CALCULADOR DE EVALUACIÓN DE RIESGO de nuestra agencia algunas brechas en su cobertura y asegurarme que yo no pase por alto ningun descuento."
  },
  wizard1_liability_script_requote: {
    es:
      '"Hello Mr./Mrs. {{wizard.first_name+" "+wizard.last_name}}, This is {{user.first_name}} calling from Allstate. How are you today?"<br/>"I\'m calling to continue our conversation from last time we spoke. We have some great rates in your area and would like the opportunity to requote your insurance."'
  },
  "you can take full advantage of all that B-File will do for you.": {
    es:
      "puedan adquirir todas las ventajas de todo lo que un Archivo-B puede hacer por ustedes.."
  },
  Welcome: {
    es: "Bienvenido"
  },
  // New Add Languages
  type_of_call: {
    en: "Type of Call"
  },
  sub_type_of_call: {
    en: "Sub-Type"
  },
  farm_bureau_number: {
    en: "Farm Bureau Number"
  }
};



// WEBPACK FOOTER //
// ./src/lang/translation.js